// CreateExam.jsx - نسخه نهایی با فیلدهای آبشاری پایه، کتاب، فصل و درس + پشتیبانی کامل از "سایر" با دکمه ثبت
// ============================================================

import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import './CreateExam.css';
import { useExams, toNumber, sanitizeHtml as sanitizeHtmlGlobal, isGlobalAdmin, GLOBAL_ADMINS } from './ExamContext.jsx';
import moment from 'moment-jalaali';
import html2pdf from 'html2pdf.js';
import { useAuth } from '../../context/AuthContext.jsx';

import { uploadImage, deleteImage, getImageUrl, moveExamImages } from '../../services/ImageService';

// 🔽 CHANGED: curriculum helpers برای پشتیبانی از پایه ۷-۱۲ و رشته‌های متوسطه دوم
import {
  GRADE_LIST,
  FIELD_LIST,
  getGrade as getGradeMeta,
  getField as getFieldMeta,
  getFieldOptions,
  getSubjectTitle,
  getSubjectsFor,
  needsField as curriculumNeedsField,
  normalizeFieldId as curriculumNormalizeField,
  isHighSchool as curriculumIsHighSchool,
} from '../../core/education/curriculum.js';

// ===== تابع تبدیل اعداد انگلیسی به فارسی =====
const toPersianDigits = (num) => {
  if (num === undefined || num === null) return '';
  const id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return num.toString().replace(/[0-9]/g, (w) => id[+w]);
};

// ===== تابع تبدیل حروف انگلیسی به فارسی (برای گزینه‌ها) =====
const toPersianLetter = (letter) => {
  const map = {
    'A': 'الف', 'B': 'ب', 'C': 'پ', 'D': 'ت',
    'E': 'ث', 'F': 'ج', 'G': 'چ', 'H': 'ح',
    'I': 'خ', 'J': 'د', 'K': 'ذ', 'L': 'ر',
    'M': 'ز', 'N': 'ژ', 'O': 'س', 'P': 'ش',
    'Q': 'ص', 'R': 'ض', 'S': 'ط', 'T': 'ظ',
    'U': 'ع', 'V': 'غ', 'W': 'ف', 'X': 'ق',
    'Y': 'ک', 'Z': 'گ'
  };
  return map[letter] || letter;
};

// ===== تابع کمکی برای ترکیب کلاس‌ها =====
const classNames = (...classes) => classes.filter(Boolean).join(' ');

// ===== داده‌های آموزشی برای انتخاب پایه، کتاب، فصل و درس =====
const curriculumData = {
  "پایه اول": {
    books: {
      "ریاضی": { chapters: ["فصل ۱", "فصل ۲", "فصل ۳", "فصل ۴" ,"فصل ۵", "فصل ۶", "فصل ۷", "فصل ۸","فصل ۹", "فصل ۱۰", "فصل ۱۱", "فصل ۱۲" ,"فصل ۱۳", "فصل ۱۴", "فصل ۱۵", "فصل ۱۶","فصل ۱۷", "فصل ۱۸", "فصل ۱۹", "فصل ۲۰" ,"فصل ۲۱", "فصل ۲۲", "فصل ۲۳", "فصل ۲۴"],lessons: [""]  },
      "علوم": { chapters: ["فصل ۱: زنگ علوم", "فصل ۲: سلام,به من نگاه کن", "فصل ۳: سالم باش,شاداب باش", "فصل ۴: دنیای جانوران" ,"فصل ۵: دنیای گیاهان", "فصل ۶: زمین خانه پر از آب ما", "فصل ۷: زمین خانه سنگی ما", "فصل ۸: چه میخواهم بسازم","فصل ۹: زمین خانه خاکی ما", "فصل ۱۰: در اطراف ما هوا وجود دارد", "فصل ۱۱: دنیای سرد و گرم", "فصل ۱۲: از خانه تا مدرسه" ,"فصل ۱۳: آهن ربای من", "فصل ۱۴: از گذشته تا آینده"], lessons: [""] },
      "فارسی": { chapters: ["بخش ۱: نگاره‌ها", "بخش ۲:آموزش نشانه‌ها۱","بخش ۳:آموزش نشانه‌ها۲","بخش ۴: روان خوانی"], lessons: ["درس ۱: آ - ب", "درس ۲: اَ - د", "درس ۳: م - س","درس ۴: او - ت" ,"درس ۵: ر - ن", "درس ۶: ای - ز","درس ۷: اِ - ش", "درس ۸: ی - اُ","درس ۹: ک - و", "درس ۱۰: پ - گ", "درس ۱۱: ف - خ", "درس ۱۲: ق - ل" ,"درس ۱۳: ج - _ُ", "درس ۱۴: ه - چ", "درس ۱۵: ژ - خوا", "درس ۱۶: تشدید","درس ۱۷: ص - ذ", "درس ۱۸: ع - ث", "درس ۱۹: ح ", "درس ۲۰: ض - ط" ,"درس ۲۱: غ", "درس ۲۲: ظ"] },
      "قرآن": { chapters: ["درس ۱: به نام خدا بسم الله (سوره توحید)", "درس ۲: نعمت های خدا (سوره کوثر)", "درس ۳: خانه ما (سوره عصر)","درس ۴: قرآن بخوانیم (سوره ناس)" ,"درس ۵: کودک مسلمان (سوره حمد)", "درس ۶: مدرسه ما (سوره فلق)","درس ۷: پیامبران خدا (سوره نصر)", "درس ۸: سوره ها "], lessons: [""] }
    }
  },
  "پایه دوم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: عدد و رقم", "فصل ۲: جمع و تفریق اعداد دو رقمی", "فصل ۳: اشکال هندسی", "فصل ۴: عدد های سه رقمی" ,"فصل ۵: اندازه گیری", "فصل ۶: جمع و تفریق اعداد سه رقمی", "فصل ۷: کسر و احتمال ", "فصل ۸: آمار و نمودار"], lessons: [] },
      "علوم": { chapters: ["فصل ۱: جانوران", "فصل ۲: گیاهان"], lessons: ["درس ۱: حیوانات خانگی", "درس ۲: گیاهان اطراف ما"] },
      "فارسی": { chapters: ["فصل ۱: نشانه‌ها", "فصل ۲: جمله‌سازی"], lessons: ["درس ۱: نشانه‌های جدید", "درس ۲: جمله‌های ساده"] }
    }
  },
  "پایه سوم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: الگوها", "فصل ۲: ضرب"], lessons: ["درس ۱: الگوی عددی", "درس ۲: جدول ضرب"] },
      "علوم": { chapters: ["فصل ۱: مواد", "فصل ۲: انرژی"], lessons: ["درس ۱: مواد اطراف", "درس ۲: گرما و نور"] },
      "فارسی": { chapters: ["فصل ۱: خواندنی‌ها", "فصل ۲: نوشتنی‌ها"], lessons: ["درس ۱: داستان‌های آموزنده", "درس ۲: انشا ساده"] }
    }
  },
  "پایه چهارم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: اعداد بزرگ", "فصل ۲: تقسیم"], lessons: ["درس ۱: عددنویسی تا ۱۰۰۰", "درس ۲: تقسیم با باقیمانده"] },
      "علوم": { chapters: ["فصل ۱: بدن انسان", "فصل ۲: زمین"], lessons: ["درس ۱: دستگاه گوارش", "درس ۲: لایه‌های زمین"] },
      "فارسی": { chapters: ["فصل ۱: حکایت‌ها", "فصل ۲: شعرها"], lessons: ["درس ۱: حکایت گلستان", "درس ۲: شعر پروین"] }
    }
  },
  "پایه پنجم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: اعشار", "فصل ۲: درصد"], lessons: ["درس ۱: اعداد اعشاری", "درس ۲: محاسبه درصد"] },
      "علوم": { chapters: ["فصل ۱: سلول", "فصل ۲: نور"], lessons: ["درس ۱: سلول‌های بدن", "درس ۲: بازتاب نور"] },
      "فارسی": { chapters: ["فصل ۱: متون ادبی", "فصل ۲: نگارش"], lessons: ["درس ۱: متن‌های کهن", "درس ۲: نوشتن نامه"] }
    }
  },
  "پایه ششم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: کسرها", "فصل ۲: نسبت"], lessons: ["درس ۱: جمع و تفریق کسر", "درس ۲: نسبت و تناسب"] },
      "علوم": { chapters: ["فصل ۱: الکتریسیته", "فصل ۲: مواد"], lessons: ["درس ۱: مدار الکتریکی", "درس ۲: تغییرات مواد"] },
      "فارسی": { chapters: ["فصل ۱: شاهنامه", "فصل ۲: ادبیات معاصر"], lessons: ["درس ۱: داستان رستم", "درس ۲: شعر نیما"] }
    }
  },
};


// ============================================================
// 🔽 CHANGED: داده‌ی خودکار برای پایه‌های ۷-۱۲ از curriculum
// ----------------------------------------------------------------
// • برای پایه‌های ۷-۹: ساختار تخت (فقط books)
// • برای پایه‌های ۱۰-۱۲: ساختار تو در تو (fields → books)
// ============================================================

const GENERIC_CHAPTERS_9_12 = [
  'فصل ۱', 'فصل ۲', 'فصل ۳', 'فصل ۴', 'فصل ۵', 'فصل ۶',
  'فصل ۷', 'فصل ۸', 'فصل ۹', 'فصل ۱۰',
];

// پر کردن خودکار برای ۷-۹
GRADE_LIST
  .filter((g) => ['7', '8', '9'].includes(g.id))
  .forEach((g) => {
    const books = {};
    getSubjectsFor(g.id).forEach((s) => {
      books[s.title] = {
        chapters: [...GENERIC_CHAPTERS_9_12],
        lessons: [],
      };
    });
    if (!curriculumData[g.title]) {
      curriculumData[g.title] = { books };
    }
  });

// پر کردن خودکار برای ۱۰-۱۲ با ساختار رشته‌ای
GRADE_LIST
  .filter((g) => ['10', '11', '12'].includes(g.id))
  .forEach((g) => {
    const fields = {};
    FIELD_LIST.forEach((f) => {
      const books = {};
      getSubjectsFor(g.id, f.id).forEach((s) => {
        // استفاده از عنوان کتاب با شماره — مثل «فارسی (۱)»
        const bookTitle = getSubjectTitle(g.id, s.id);
        books[bookTitle] = {
          chapters: [...GENERIC_CHAPTERS_9_12],
          lessons: [],
        };
      });
      fields[f.title] = { books };  // f.title مثل «ریاضی و فیزیک»
    });
    if (!curriculumData[g.title]) {
      curriculumData[g.title] = { fields };
    }
  });

// ============================================================
// 🔽 CHANGED: gradeOptions شامل همه‌ی پایه‌ها با ترتیب درست
// ============================================================

// ترتیب: پایه اول، پایه دوم، ..., پایه دوازدهم


const gradeOptions = Object.keys(curriculumData);

// ===== کامپوننت ویرایشگر ساده (جایگزین RichTextEditor) =====
const SimpleTextEditor = ({ value, onChange, placeholder }) => {
  return (
    <textarea
      className="simpleTextarea"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={4}
    />
  );
};

// ===== کامپوننت فرمول ریاضی =====
const MathEditor = ({ value, onChange }) => {
  const [showMath, setShowMath] = useState(false);
  const [latexValue, setLatexValue] = useState(value || '');
  const inputRef = useRef(null);
  const mathSymbols = ['∑','∫','π','∞','±','×','÷','≠','≤','≥','α','β','γ','δ','ε','θ','λ','μ','σ','ω','∂','∇','∆','∏','∛','∜','⊂','⊃','∈','∉','∪','∩','∅','ℕ','ℤ','ℚ','ℝ','ℂ','sin','cos','tan','log','ln','lim','→','√'];

  const handleSymbolClick = (sym) => {
    const newValue = latexValue + sym;
    setLatexValue(newValue);
    onChange(newValue);
    if (inputRef.current) inputRef.current.focus();
  };

  return (
    <div className="mathEditor">
      <button type="button" className="mathToggle" onClick={() => setShowMath(!showMath)}>
        {showMath ? '🔽 مخفی فرمول' : '➕ فرمول ریاضی'}
      </button>
      {showMath && (
        <div className="mathPanel">
          <div className="mathSymbols">
            {mathSymbols.map(sym => (
              <button key={sym} type="button" className="mathSymbol" onClick={() => handleSymbolClick(sym)}>
                {sym}
              </button>
            ))}
          </div>
          <input
            ref={inputRef}
            type="text"
            className="mathInput"
            value={latexValue}
            onChange={e => { setLatexValue(e.target.value); onChange(e.target.value); }}
            placeholder="فرمول را وارد کنید..."
          />
          <div className="mathPreview">
            <span>پیش‌نمایش: </span>
            <span className="mathPreviewContent">{latexValue || '(خالی)'}</span>
          </div>
        </div>
      )}
    </div>
  );
};

// ===== کامپوننت سوال شرطی =====
const ConditionalQuestion = ({ index, questions, onConditionChange, initialCondition }) => {
  const [condition, setCondition] = useState(initialCondition || { dependsOn: null, operator: 'equal', value: '' });
  const availableQuestions = useMemo(() => questions.filter((_, idx) => idx < index), [questions, index]);

  const handleChange = (field, val) => {
    const newCondition = { ...condition, [field]: val };
    setCondition(newCondition);
    onConditionChange(newCondition);
  };

  return (
    <div className="conditionalSection">
      <label className="fieldLabel">🎯 سوال شرطی:</label>
      <div className="conditionalRow">
        <select className="selectInput" value={condition.dependsOn ?? ''} onChange={e => handleChange('dependsOn', e.target.value ? parseInt(e.target.value, 10) : null)}>
          <option value="">-- وابسته به سوال --</option>
          {availableQuestions.map((q, idx) => <option key={q.id} value={idx}>سوال {idx + 1}</option>)}
        </select>
        <select className="selectInput" value={condition.operator} onChange={e => handleChange('operator', e.target.value)}>
          <option value="equal">برابر با</option>
          <option value="notEqual">مخالف با</option>
          <option value="greater">بزرگتر از</option>
          <option value="less">کوچکتر از</option>
          <option value="contains">شامل</option>
        </select>
        <input type="text" className="textInput" placeholder="مقدار شرط" value={condition.value} onChange={e => handleChange('value', e.target.value)} />
      </div>
    </div>
  );
};

// ============================================================
// ===== کامپوننت انتخابگر تاریخ شمسی با moment-jalaali =====
// ============================================================
const PersianDatePicker = ({ value, onChange, placeholder, className }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [tempValue, setTempValue] = useState(value || '');
  const inputRef = useRef(null);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target) &&
          inputRef.current && !inputRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setTempValue(val);
    if (val && moment(val, 'jYYYY-jMM-jDD', true).isValid()) {
      onChange(val);
    } else if (!val) {
      onChange('');
    }
  };

  const handleDateSelect = (day, month, year) => {
    const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    setTempValue(dateStr);
    onChange(dateStr);
    setShowPicker(false);
  };

  const goToToday = () => {
    const today = moment().format('jYYYY-jMM-jDD');
    setTempValue(today);
    onChange(today);
    setShowPicker(false);
  };

  const goToMonth = (delta) => {
    let currentDate = tempValue || moment().format('jYYYY-jMM-jDD');
    const newDate = moment(currentDate, 'jYYYY-jMM-jDD').add(delta, 'jMonth').format('jYYYY-jMM-jDD');
    setTempValue(newDate);
    onChange(newDate);
  };

  const getDaysInMonth = (jalaliDate) => {
    let m;
    if (jalaliDate && moment(jalaliDate, 'jYYYY-jMM-jDD', true).isValid()) {
      m = moment(jalaliDate, 'jYYYY-jMM-jDD');
    } else {
      m = moment();
    }
    return {
      year: m.jYear(),
      month: m.jMonth() + 1,
      days: m.daysInMonth(),
      firstDayOfWeek: moment(`${m.jYear()}/${m.jMonth() + 1}/1`, 'jYYYY/jMM/jDD').day(),
    };
  };

  const currentDate = tempValue || value || moment().format('jYYYY-jMM-jDD');
  const { year, month, days, firstDayOfWeek } = getDaysInMonth(currentDate);
  const weekDays = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];
  const offset = (firstDayOfWeek + 1) % 7;
  const monthNames = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];

  return (
    <div className="persian-datepicker-wrapper">
      <input
        ref={inputRef}
        type="text"
        className={className || 'textInput'}
        value={tempValue}
        onChange={handleInputChange}
        placeholder={placeholder || 'انتخاب تاریخ...'}
        onFocus={() => setShowPicker(true)}
        onClick={() => setShowPicker(true)}
        autoComplete="off"
      />
      {showPicker && (
        <div className="persian-datepicker-popup" ref={pickerRef}>
          <div className="pdp-header">
            <button className="pdp-nav" onClick={() => goToMonth(-1)}>◀</button>
            <span className="pdp-month">{monthNames[month - 1]} {toPersianDigits(year)}</span>
            <button className="pdp-nav" onClick={() => goToMonth(1)}>▶</button>
            <button className="pdp-today" onClick={goToToday} title="امروز">📍</button>
          </div>
          <div className="pdp-weekdays">
            {weekDays.map(d => <span key={d}>{d}</span>)}
          </div>
          <div className="pdp-days">
            {Array.from({ length: offset }, (_, i) => <span key={`empty-${i}`} className="pdp-empty"></span>)}
            {Array.from({ length: days }, (_, i) => {
              const day = i + 1;
              const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
              const isToday = moment().format('jYYYY-jMM-jDD') === dateStr;
              const isSelected = currentDate === dateStr;
              return (
                <span
                  key={day}
                  className={`pdp-day ${isToday ? 'today' : ''} ${isSelected ? 'selected' : ''}`}
                  onClick={() => handleDateSelect(day, month, year)}
                >
                  {toPersianDigits(day)}
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

// ============================================================
// ===== کامپوننت انتخابگر زمان با قالب ۱۲ ساعته (AM/PM) =====
// ============================================================
const TimePicker = ({ value, onChange, placeholder, label, minTime }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [hour, setHour] = useState('');
  const [minute, setMinute] = useState('');
  const [period, setPeriod] = useState('AM');
  const pickerRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (value) {
      const parts = value.split(':');
      if (parts.length === 2) {
        const h = parseInt(parts[0]);
        const m = parseInt(parts[1]);
        setHour(String(h).padStart(2, '0'));
        setMinute(String(m).padStart(2, '0'));
        setPeriod(h >= 12 ? 'PM' : 'AM');
      }
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target) &&
          inputRef.current && !inputRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const [minHour, setMinHour] = useState(null);
  const [minMinute, setMinMinute] = useState(null);

  useEffect(() => {
    if (minTime) {
      const parts = minTime.split(':');
      if (parts.length === 2) {
        setMinHour(parseInt(parts[0]));
        setMinMinute(parseInt(parts[1]));
      }
    } else {
      setMinHour(null);
      setMinMinute(null);
    }
  }, [minTime]);

  const handleTimeSelect = (h, m) => {
    let hour24 = h;
    if (period === 'PM' && h !== 12) hour24 = h + 12;
    if (period === 'AM' && h === 12) hour24 = 0;
    const timeStr = `${String(hour24).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    setHour(String(h).padStart(2, '0'));
    setMinute(String(m).padStart(2, '0'));
    onChange(timeStr);
    setShowPicker(false);
  };

  const hours12 = Array.from({ length: 12 }, (_, i) => i + 1);
  const minutes = Array.from({ length: 60 }, (_, i) => i);
  const currentHour = hour ? parseInt(hour) : 0;
  const currentMinute = minute ? parseInt(minute) : 59;
  const displayHour = currentHour > 12 ? currentHour - 12 : (currentHour === 0 ? 12 : currentHour);

  const displayValue = value ? `${toPersianDigits(displayHour)}:${toPersianDigits(minute || '00')} ${period}` : '';

  return (
    <div className="time-picker-wrapper">
      <input
        ref={inputRef}
        type="text"
        className="textInput time-input"
        value={displayValue}
        placeholder={placeholder || 'ساعت:دقیقه'}
        onFocus={() => setShowPicker(true)}
        onClick={() => setShowPicker(true)}
        readOnly
        autoComplete="off"
      />
      <span className="time-picker-icon" onClick={() => setShowPicker(!showPicker)}></span>
      {showPicker && (
        <div className="time-picker-popup" ref={pickerRef}>
          <div className="time-picker-header">
            <span className="time-picker-label">{label || 'انتخاب زمان'}</span>
            <button className="time-picker-close" onClick={() => setShowPicker(false)}>✕</button>
          </div>
          <div className="time-picker-body">
            <div className="time-picker-column">
              <div className="time-picker-column-header">دقیقه</div>
              <div className="time-picker-scroll">
                {minutes.map(m => {
                  let isDisabled = false;
                  if (minHour !== null && minMinute !== null) {
                    const currentHour24 = currentHour || 0;
                    if (currentHour24 < minHour) isDisabled = true;
                    if (currentHour24 === minHour && m < minMinute) isDisabled = true;
                  }
                  return (
                    <div
                      key={m}
                      className={`time-picker-item ${currentMinute === m ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                      onClick={() => {
                        if (isDisabled) return;
                        const h = currentHour || 0;
                        const timeStr = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
                        setMinute(String(m).padStart(2, '0'));
                        onChange(timeStr);
                        if (hour && m !== undefined) {
                          setShowPicker(false);
                        }
                      }}
                      style={isDisabled ? { opacity: '0.3', cursor: 'not-allowed' } : {}}
                    >
                      {toPersianDigits(String(m).padStart(2, '0'))}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="time-picker-divider">:</div>
            <div className="time-picker-column">
              <div className="time-picker-column-header">ساعت</div>
              <div className="time-picker-scroll">
                {hours12.map(h => {
                  let h24 = h;
                  if (period === 'PM' && h !== 12) h24 = h + 12;
                  if (period === 'AM' && h === 12) h24 = 0;
                  let isDisabled = false;
                  if (minHour !== null && minMinute !== null) {
                    if (h24 < minHour) isDisabled = true;
                    if (h24 === minHour && parseInt(currentMinute) < minMinute) isDisabled = true;
                    if (h24 === minHour && parseInt(currentMinute) === minMinute) isDisabled = true;
                  }
                  return (
                    <div
                      key={h}
                      className={`time-picker-item ${displayHour === h ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                      onClick={() => {
                        if (isDisabled) return;
                        let h24 = h;
                        if (period === 'PM' && h !== 12) h24 = h + 12;
                        if (period === 'AM' && h === 12) h24 = 0;
                        const timeStr = `${String(h24).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;
                        setHour(String(h24).padStart(2, '0'));
                        onChange(timeStr);
                      }}
                      style={isDisabled ? { opacity: '0.3', cursor: 'not-allowed' } : {}}
                    >
                      {toPersianDigits(String(h).padStart(2, '0'))}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="time-picker-period">
              <button
                className={`time-picker-period-btn ${period === 'AM' ? 'active' : ''}`}
                onClick={() => {
                  setPeriod('AM');
                  if (hour) {
                    let h = parseInt(hour);
                    if (h >= 12) h = h - 12;
                    const timeStr = `${String(h).padStart(2, '0')}:${minute || '00'}`;
                    onChange(timeStr);
                  }
                }}
              >
                قبل از ظهر
              </button>
              <button
                className={`time-picker-period-btn ${period === 'PM' ? 'active' : ''}`}
                onClick={() => {
                  setPeriod('PM');
                  if (hour) {
                    let h = parseInt(hour);
                    if (h < 12) h = h + 12;
                    const timeStr = `${String(h).padStart(2, '0')}:${minute || '00'}`;
                    onChange(timeStr);
                  }
                }}
              >
                بعد از ظهر
              </button>
            </div>
          </div>
          <div className="time-picker-footer">
            <button className="time-picker-now" onClick={() => {
              const now = moment();
              const h = now.format('HH');
              const m = now.format('mm');
              setHour(h);
              setMinute(m);
              setPeriod(parseInt(h) >= 12 ? 'PM' : 'AM');
              onChange(`${h}:${m}`);
              setShowPicker(false);
            }}>
              ⏰ اکنون
            </button>
            <button className="time-picker-clear" onClick={() => {
              setHour('');
              setMinute('');
              setPeriod('AM');
              onChange('');
              setShowPicker(false);
            }}>
              ✕ پاک کردن
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// ============================================================
// ===== کامپوننت اصلی =====
// ============================================================
const CreateExam = ({ __stepQuizContext = null }) => {   // 🆕
  const navigate = useNavigate();
  const { examId } = useParams();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode'); // 'global' یا 'challenge'

  // 🆕 Step Quiz Mode
  const isStepQuizMode = !!__stepQuizContext;
  const stepQuizInitialData = __stepQuizContext?.initialData || null;
  const stepQuizOnSave = __stepQuizContext?.onSave || null;
  const stepQuizOnCancel = __stepQuizContext?.onCancel || null;
  const stepQuizOnSuccess = __stepQuizContext?.onSuccess || null;   // 🆕
  
  const { exams, addExam, updateExam, getExam, getTeamTotalStudents } = useExams();


  const { user } = useAuth();
  const currentTeacherId = user?.id || null;
  const isAdmin = isGlobalAdmin(currentTeacherId);

  const [teacherTeamId, setTeacherTeamId] = useState(null);
  const [teamTotalStudents, setTeamTotalStudents] = useState(0);

  useEffect(() => {
    let foundTeamId = null;
    const storedTeam = localStorage.getItem('team');
    if (storedTeam) {
      try { const team = JSON.parse(storedTeam); if (team && team.id) foundTeamId = team.id; } catch { /* ignore */ }
    }
    if (!foundTeamId) {
      const storedMembers = localStorage.getItem('teamMembers');
      if (storedMembers) {
        try {
          const parsed = JSON.parse(storedMembers);
          const teacherMember = parsed.find(m => m.studentId === currentTeacherId && m.status === 'active');
          if (teacherMember) foundTeamId = teacherMember.teamId;
        } catch { /* ignore */ }
      }
    }
    setTeacherTeamId(foundTeamId);
    if (foundTeamId && foundTeamId !== 'no-group') setTeamTotalStudents(getTeamTotalStudents(foundTeamId));
  }, [currentTeacherId, getTeamTotalStudents]);

  const existingExam = examId ? getExam(examId) : null;
  const isEditing = !!existingExam;

  const [endTimeError, setEndTimeError] = useState('');


    // 🌗 state تم تیره برای این صفحه
const [isDarkMode, setIsDarkMode] = useState(() => {
  try {
    return localStorage.getItem('navbar2-drawer-dark') === '1';
  } catch {
    return false;
  }
});

const toggleTheme = () => setIsDarkMode((prev) => !prev);

// ذخیره در کلید مشترک Navbar2
useEffect(() => {
  try {
    localStorage.setItem('navbar2-drawer-dark', isDarkMode ? '1' : '0');
  } catch { /* ignore */ }
}, [isDarkMode]);

// گوش دادن به تغییرات Navbar2 (storage بین تب‌ها + polling داخل همون تب)
useEffect(() => {
  const handleStorage = (e) => {
    if (e.key === 'navbar2-drawer-dark') {
      setIsDarkMode(e.newValue === '1');
    }
  };
  window.addEventListener('storage', handleStorage);

  const interval = setInterval(() => {
    try {
      const current = localStorage.getItem('navbar2-drawer-dark') === '1';
      setIsDarkMode((prev) => (prev !== current ? current : prev));
    } catch {}
  }, 500);

  return () => {
    window.removeEventListener('storage', handleStorage);
    clearInterval(interval);
  };
}, []);

// ✅ حل مشکل ورودی‌های عددی در موبایل — انتخاب خودکار متن هنگام فوکوس
useEffect(() => {
  const handleFocusIn = (e) => {
    const input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'number') return;

    // ترفند: تغییر موقت type به text تا select() روی موبایل کار کنه
    const originalType = input.type;
    input.type = 'text';
    input.select();
    input.type = originalType;
  };

  document.addEventListener('focusin', handleFocusIn, true);
  return () => document.removeEventListener('focusin', handleFocusIn, true);
}, []);

  // ===== Stateهای اصلی =====
  const [examInfo, setExamInfo] = useState({
    title: '',
    description: '',
    book: '',
    class: '',
    date: moment().format('jYYYY-jMM-jDD'),
    duration: '',
    shuffleQuestions: false,
    shuffleOptions: false,
    showResult: true,
    showCorrectAnswers: true,
    limitAttempts: 1,
    displayMode: 'step',
    startTime: '',
    endTime: '',
    image: null,
    ipRestriction: '',
    teamId: null,
    teacherId: currentTeacherId,
    totalStudents: 0,
    isGlobal: false,
    grade: '',
    field: null,        // 🔽 CHANGED: شناسه رشته (riazi | tajrobi | ensani)
    fieldTitle: '',     // 🔽 CHANGED: عنوان فارسی رشته برای نمایش
    subject: '',
    chapter: '',
    _gregorianDate: '',
    isChallenge: false,
    isDailyChallenge: false,
    coinsExcellent: 0,
    xpExcellent: 0,
    coinsVeryGood: 0,
    xpVeryGood: 0,
    coinsGood: 0,
    xpGood: 0,
    coinsNeedsWork: 0,
    xpNeedsWork: 0,
    coinsUnacceptable: 0,
    xpUnacceptable: 0,
    coinsFailed: 0,
    xpFailed: 0,
    // 🆕 badge controls (admin only)
    requiredCoins: 0,
    forceNew: false,
    forceHot: false,
    newBadgeDuration: 24,
    hotThresholdParticipants: 1000,
    hotThresholdRecentResults: 100,
  });

  // 🆕 مقداردهی از initialData در Step Quiz Mode
useEffect(() => {
  if (!isStepQuizMode || !stepQuizInitialData) return;
  setExamInfo((prev) => ({
    ...prev,
    ...stepQuizInitialData,
    isGlobal: false,
    isChallenge: false,
    isDailyChallenge: false,
    teamId: null,
  }));
  if (Array.isArray(stepQuizInitialData.questions)) {
    setQuestions(stepQuizInitialData.questions);
  }
}, [isStepQuizMode, stepQuizInitialData]);

  // ===== Stateهای مربوط به فیلدهای آبشاری =====
  const [availableBooks, setAvailableBooks] = useState([]);
  const [availableChapters, setAvailableChapters] = useState([]);
  const [availableLessons, setAvailableLessons] = useState([]);
  const [customGrade, setCustomGrade] = useState('');
  const [customBook, setCustomBook] = useState('');
  const [customChapter, setCustomChapter] = useState('');
  const [customSubject, setCustomSubject] = useState('');

  // 🔽 CHANGED: لیست رشته‌های موجود برای پایه انتخاب‌شده
  const [availableFields, setAvailableFields] = useState([]);

  // ===== Stateهای تأیید برای فیلدهای "سایر" =====
  const [customGradeConfirmed, setCustomGradeConfirmed] = useState(false);
  const [customBookConfirmed, setCustomBookConfirmed] = useState(false);
  const [customChapterConfirmed, setCustomChapterConfirmed] = useState(false);
  const [customSubjectConfirmed, setCustomSubjectConfirmed] = useState(false);

  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState({
    id: null,
    type: 'multiple',
    question: '',
    options: ['','','',''],
    correctAnswer: 0,
    correctAnswers: [],
    fillAnswers: [''],
    score: 1,
    image: null,
    file: null,
    required: false,
    timeLimit: null,
    conditional: null,
    mathFormula: '',
    matchingPairs: [{ left: '', right: '' }],
    orderItems: ['','',''],
  });
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [saving, setSaving] = useState(false);
  const [questionType, setQuestionType] = useState('multiple');

  // 🆕 باز/بسته بودن بخش تنظیمات پیشرفته (پیش‌فرض: بسته)
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUploadingExamImage, setIsUploadingExamImage] = useState(false);
  const [isUploadingQuestionImage, setIsUploadingQuestionImage] = useState(false);

  // ===== Ref برای PDF =====
  const pdfContentRef = useRef(null);

  // ===== محاسبه مجموع نمرات =====
  const totalScore = useMemo(() => {
    return questions.reduce((sum, q) => sum + toNumber(q.score, 0), 0);
  }, [questions]);

  const isTotalScoreValid = totalScore === 20;
  const isTotalScoreExceeded = totalScore > 20;
  const canAddQuestion = !isTotalScoreExceeded;

  // ===== Ref برای بخش افزودن سوال (برای اسکرول) =====
  const addQuestionAreaRef = useRef(null);

  

  // 🆕 کلید draft — هر معلم / هر آزمون یک کلید جداگانه دارد
  const DRAFT_KEY = (!currentTeacherId || isStepQuizMode)
    ? null
    : (examId
        ? `exam-draft-v1-${currentTeacherId}-${examId}`
        : `exam-draft-v1-${currentTeacherId}-new`);

  // ===== بارگذاری داده‌های آزمون در حالت ویرایش یا تنظیم اولیه بر اساس mode =====
  useEffect(() => {
    if (existingExam) {
      let examDate = existingExam.date || moment().format('jYYYY-jMM-jDD');
      let startTime = existingExam.startTime || '';
      let endTime = existingExam.endTime || '';

      if (examDate && examDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
        try {
          const m = moment(examDate, 'YYYY-MM-DD');
          if (m.isValid()) examDate = m.format('jYYYY-jMM-jDD');
        } catch (e) {}
      }

      if (startTime && startTime.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/)) {
        try {
          const m = moment(startTime);
          if (m.isValid()) {
            startTime = m.format('HH:mm');
          }
        } catch (e) {}
      } else if (startTime && startTime.match(/^\d{2}:\d{2}$/)) {
        startTime = startTime;
      } else {
        startTime = '';
      }

      if (endTime && endTime.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/)) {
        try {
          const m = moment(endTime);
          if (m.isValid()) {
            endTime = m.format('HH:mm');
          }
        } catch (e) {}
      } else if (endTime && endTime.match(/^\d{2}:\d{2}$/)) {
        endTime = endTime;
      } else {
        endTime = '';
      }

      // ===== 🔽 CHANGED: تشخیص مقادیر سفارشی (سایر) قبل از بارگذاری =====
      const existingGrade = existingExam.grade || '';
      const existingFieldRaw = existingExam.field;
      const existingField = existingFieldRaw ? (curriculumNormalizeField(existingFieldRaw) || null) : null;
      const existingFieldTitle = existingExam.fieldTitle
        || (existingField ? (getFieldMeta(existingField)?.title || '') : '');
      const existingBook = existingExam.book || '';
      const existingChapter = existingExam.chapter || '';
      const existingSubject = existingExam.subject || '';

      const gradeIsCustom = !!existingGrade && !gradeOptions.includes(existingGrade);

      let defaultBookList = [];
      let defaultChapterList = [];
      let defaultLessonList = [];
      const detectGradeData = (!gradeIsCustom && existingGrade) ? curriculumData[existingGrade] : null;

      if (detectGradeData) {
        const needsFieldHere = curriculumNeedsField(existingGrade);
        if (needsFieldHere && detectGradeData.fields && existingFieldTitle && detectGradeData.fields[existingFieldTitle]) {
          const fd = detectGradeData.fields[existingFieldTitle];
          defaultBookList = Object.keys(fd.books);
          if (existingBook && defaultBookList.includes(existingBook)) {
            const bd = fd.books[existingBook];
            defaultChapterList = bd.chapters || [];
            defaultLessonList = bd.lessons || [];
          }
        } else if (!needsFieldHere && detectGradeData.books) {
          defaultBookList = Object.keys(detectGradeData.books);
          if (existingBook && defaultBookList.includes(existingBook)) {
            const bd = detectGradeData.books[existingBook];
            defaultChapterList = bd.chapters || [];
            defaultLessonList = bd.lessons || [];
          }
        }
      }

      const bookIsCustom = !!existingBook && !defaultBookList.includes(existingBook);
      const chapterIsCustom = !!existingChapter && !defaultChapterList.includes(existingChapter);
      const lessonIsCustom = !!existingSubject && !defaultLessonList.includes(existingSubject);

      if (gradeIsCustom) {
        setCustomGrade(existingGrade);
        setCustomGradeConfirmed(true);
      }
      if (bookIsCustom) {
        setCustomBook(existingBook);
        setCustomBookConfirmed(true);
      }
      if (chapterIsCustom) {
        setCustomChapter(existingChapter);
        setCustomChapterConfirmed(true);
      }
      if (lessonIsCustom) {
        setCustomSubject(existingSubject);
        setCustomSubjectConfirmed(true);
      }

      setExamInfo({
        title: existingExam.title || '',
        description: existingExam.description || '',
        book: bookIsCustom ? 'سایر' : existingBook,
        class: existingExam.class || '',
        date: examDate,
        duration: existingExam.duration || '',
        shuffleQuestions: existingExam.shuffleQuestions || false,
        shuffleOptions: existingExam.shuffleOptions || false,
        showResult: existingExam.showResult !== undefined ? existingExam.showResult : true,
        showCorrectAnswers: existingExam.showCorrectAnswers !== undefined ? existingExam.showCorrectAnswers : true,
        limitAttempts: existingExam.limitAttempts || 1,
        displayMode: existingExam.displayMode || 'step',
        startTime: startTime,
        endTime: endTime,
        image: existingExam.image || null,
        ipRestriction: existingExam.ipRestriction || '',
        teamId: existingExam.teamId || teacherTeamId,
        teacherId: existingExam.teacherId || currentTeacherId,
        totalStudents: existingExam.totalStudents || teamTotalStudents || 0,
        isGlobal: existingExam.isGlobal || false,
        grade: gradeIsCustom ? 'سایر' : existingGrade,
        field: existingField,
        fieldTitle: existingFieldTitle,
        subject: lessonIsCustom ? 'سایر' : existingSubject,
        chapter: chapterIsCustom ? 'سایر' : existingChapter,
        _gregorianDate: existingExam._gregorianDate || '',
        isChallenge: existingExam.isChallenge || false,
        coinsExcellent: existingExam.coinsExcellent || 0,
        xpExcellent: existingExam.xpExcellent || 0,
        coinsVeryGood: existingExam.coinsVeryGood || 0,
        xpVeryGood: existingExam.xpVeryGood || 0,
        coinsGood: existingExam.coinsGood || 0,
        xpGood: existingExam.xpGood || 0,
        coinsNeedsWork: existingExam.coinsNeedsWork || 0,
        xpNeedsWork: existingExam.xpNeedsWork || 0,
        coinsUnacceptable: existingExam.coinsUnacceptable || 0,
        xpUnacceptable: existingExam.xpUnacceptable || 0,
        coinsFailed: existingExam.coinsFailed || 0,
        xpFailed: existingExam.xpFailed || 0,
        isDailyChallenge: existingExam.isDailyChallenge || false,
      });
      setQuestions(existingExam.questions || []);
      if (existingExam.questions?.length > 0) {
        setQuestionType(existingExam.questions[0].type || 'multiple');
      }
      // 🔽 CHANGED: مقداردهی اولیه لیست‌های آبشاری با پشتیبانی از رشته
      if (existingExam.grade && curriculumData[existingExam.grade]) {
        const gradeData = curriculumData[existingExam.grade];
        const gradeNeedsFieldHere = curriculumNeedsField(existingExam.grade);

        if (gradeNeedsFieldHere && gradeData.fields) {
          // ۱۰-۱۲: ابتدا رشته‌ها
          const fieldTitles = Object.keys(gradeData.fields);
          setAvailableFields(fieldTitles);

          const storedField = existingExam.field
            ? (curriculumNormalizeField(existingExam.field) || null)
            : null;
          const fieldTitle = storedField
            ? (getFieldMeta(storedField)?.title || '')
            : (existingExam.fieldTitle || '');

          if (fieldTitle && gradeData.fields[fieldTitle]) {
            const books = Object.keys(gradeData.fields[fieldTitle].books);
            setAvailableBooks(books);
            if (existingExam.book && books.includes(existingExam.book)) {
              const bookData = gradeData.fields[fieldTitle].books[existingExam.book];
              setAvailableChapters(bookData.chapters || []);
              setAvailableLessons(bookData.lessons || []);
            }
          }
        } else if (gradeData.books) {
          // ۱-۹: بدون رشته
          const books = Object.keys(gradeData.books);
          setAvailableBooks(books);
          if (existingExam.book && books.includes(existingExam.book)) {
            const bookData = gradeData.books[existingExam.book];
            setAvailableChapters(bookData.chapters || []);
            if (existingExam.chapter && bookData.chapters?.includes(existingExam.chapter)) {
              setAvailableLessons(bookData.lessons || []);
            }
          }
        }
      }
      // اگر ویرایش است، mode را نادیده می‌گیریم
    } else {
      // حالت ایجاد جدید - اعمال تنظیمات بر اساس mode
      // 🆕 حذف شرط isAdmin: چون mode فقط از دکمه‌های مخصوص ادمین ست می‌شود،
      //    و addExam در ExamContext خودش isAdmin را چک می‌کند.
      if (mode === 'global') {
        setExamInfo(prev => ({ ...prev, isGlobal: true, isChallenge: false }));
      } else if (mode === 'challenge') {
        setExamInfo(prev => ({ ...prev, isGlobal: true, isChallenge: true }));
      } else {
        // حالت پیش‌فرض: گروهی
        setExamInfo(prev => ({ ...prev, isGlobal: false, isChallenge: false }));
      }
    }
  }, [existingExam, teacherTeamId, currentTeacherId, teamTotalStudents, mode, isAdmin]);





    // 🆕 بازیابی state پس از بازگشت از PDF
  // ⚠️ فقط یک بار روی mount اجرا می‌شود
  useEffect(() => {
    try {
      const raw = localStorage.getItem('exam-pdf-backup');
      if (!raw) return;
      localStorage.removeItem('exam-pdf-backup');
      const d = JSON.parse(raw);
      if (!d || (!d.examInfo?.title && !d.questions?.length)) return;
      setExamInfo(prev => ({ ...prev, ...d.examInfo }));
      setQuestions(Array.isArray(d.questions) ? d.questions : []);
      setCustomGrade(d.customGrade || '');
      setCustomBook(d.customBook || '');
      setCustomChapter(d.customChapter || '');
      setCustomSubject(d.customSubject || '');
      setCustomGradeConfirmed(!!d.customGradeConfirmed);
      setCustomBookConfirmed(!!d.customBookConfirmed);
      setCustomChapterConfirmed(!!d.customChapterConfirmed);
      setCustomSubjectConfirmed(!!d.customSubjectConfirmed);
    } catch {}

  }, []);



    // 🆕 ذخیره‌ی خودکار — با هر تغییر در state
  useEffect(() => {
    if (!DRAFT_KEY) return;
    // اگر فرم خالی است، draft رو پاک کن (تا draft قدیمی مزاحم نشه)
    if (!examInfo.title && !examInfo.book && !questions.length) {
      try { localStorage.removeItem(DRAFT_KEY); } catch {}
      return;
    }
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify({
        examInfo, questions,
        customGrade, customBook, customChapter, customSubject,
        customGradeConfirmed, customBookConfirmed,
        customChapterConfirmed, customSubjectConfirmed,
      }));
    } catch {}
  }, [
    DRAFT_KEY, examInfo, questions,
    customGrade, customBook, customChapter, customSubject,
    customGradeConfirmed, customBookConfirmed,
    customChapterConfirmed, customSubjectConfirmed,
  ]);






    // 🆕 بازیابی روی mount — فقط یک بار اجرا می‌شود
  const draftLoadedRef = useRef(false);
  useEffect(() => {
    if (!DRAFT_KEY || draftLoadedRef.current) return;
    draftLoadedRef.current = true;
    try {
      const raw = localStorage.getItem(DRAFT_KEY);
      if (!raw) return;
      const d = JSON.parse(raw);
      if (!d || (!d.examInfo?.title && !d.questions?.length)) return;

      // 🆕 اگر mode در URL هست، isGlobal/isChallenge/isDailyChallenge/teamId
      //    را از draft نگیر — باید از mode (بالاتر) بیاید
      const restoredExamInfo = { ...d.examInfo };
      if (mode) {
        delete restoredExamInfo.isGlobal;
        delete restoredExamInfo.isChallenge;
        delete restoredExamInfo.isDailyChallenge;
        delete restoredExamInfo.teamId;
      }

      setExamInfo(prev => ({ ...prev, ...restoredExamInfo }));
      setQuestions(Array.isArray(d.questions) ? d.questions : []);
      setCustomGrade(d.customGrade || '');
      setCustomBook(d.customBook || '');
      setCustomChapter(d.customChapter || '');
      setCustomSubject(d.customSubject || '');
      setCustomGradeConfirmed(!!d.customGradeConfirmed);
      setCustomBookConfirmed(!!d.customBookConfirmed);
      setCustomChapterConfirmed(!!d.customChapterConfirmed);
      setCustomSubjectConfirmed(!!d.customSubjectConfirmed);
    } catch {}
  }, [DRAFT_KEY, mode]);


  // ===== به‌روزرسانی لیست رشته‌ها و کتاب‌ها با تغییر پایه =====
  useEffect(() => {
    const gradeData = examInfo.grade ? curriculumData[examInfo.grade] : null;
    const gradeNeedsFieldHere = examInfo.grade ? curriculumNeedsField(examInfo.grade) : false;

    if (gradeData?.fields) {
      // ۱۰-۱۲: رشته‌ها رو پر کن، کتاب‌ها بعد از انتخاب رشته
      const fieldTitles = Object.keys(gradeData.fields);
      setAvailableFields(fieldTitles);

      // اگه رشته‌ی فعلی هنوز معتبره، کتاب‌هاش رو بگیر
      if (examInfo.fieldTitle && gradeData.fields[examInfo.fieldTitle]) {
        const books = Object.keys(gradeData.fields[examInfo.fieldTitle].books);
        setAvailableBooks(books);
        if (!books.includes(examInfo.book) && examInfo.book !== 'سایر') {
          setExamInfo((prev) => ({ ...prev, book: '', chapter: '', subject: '' }));
          setAvailableChapters([]);
          setAvailableLessons([]);
        }
      } else {
        setAvailableBooks([]);
        setAvailableChapters([]);
        setAvailableLessons([]);
      }
    } else if (gradeData?.books) {
      // ۱-۹: بدون رشته
      setAvailableFields([]);
      const books = Object.keys(gradeData.books);
      setAvailableBooks(books);
      if (!books.includes(examInfo.book) && examInfo.book !== 'سایر') {
        setExamInfo((prev) => ({ ...prev, book: '', chapter: '', subject: '' }));
        setAvailableChapters([]);
        setAvailableLessons([]);
      }
    } else {
      setAvailableFields([]);
      setAvailableBooks([]);
      setAvailableChapters([]);
      setAvailableLessons([]);
    }
  }, [examInfo.grade, examInfo.fieldTitle]);

  // ===== به‌روزرسانی لیست فصل‌ها با تغییر کتاب =====
  useEffect(() => {
    const gradeData = examInfo.grade ? curriculumData[examInfo.grade] : null;
    let bookData = null;

    if (gradeData?.fields && examInfo.fieldTitle && gradeData.fields[examInfo.fieldTitle]) {
      bookData = gradeData.fields[examInfo.fieldTitle].books[examInfo.book];
    } else if (gradeData?.books) {
      bookData = gradeData.books[examInfo.book];
    }

    if (bookData) {
      const chapters = bookData.chapters || [];
      setAvailableChapters(chapters);
      if (!chapters.includes(examInfo.chapter) && examInfo.chapter !== 'سایر') {
        setExamInfo((prev) => ({ ...prev, chapter: '', subject: '' }));
        setAvailableLessons([]);
      }
    } else {
      setAvailableChapters([]);
      setAvailableLessons([]);
    }
  }, [examInfo.grade, examInfo.fieldTitle, examInfo.book]);

  // ===== به‌روزرسانی لیست درس‌ها با تغییر فصل =====
  useEffect(() => {
    const gradeData = examInfo.grade ? curriculumData[examInfo.grade] : null;
    let bookData = null;

    if (gradeData?.fields && examInfo.fieldTitle && gradeData.fields[examInfo.fieldTitle]) {
      bookData = gradeData.fields[examInfo.fieldTitle].books[examInfo.book];
    } else if (gradeData?.books) {
      bookData = gradeData.books[examInfo.book];
    }

    if (bookData && examInfo.chapter) {
      const lessons = bookData.lessons || [];
      setAvailableLessons(lessons);
      if (!lessons.includes(examInfo.subject) && examInfo.subject !== 'سایر') {
        setExamInfo((prev) => ({ ...prev, subject: '' }));
      }
    } else {
      setAvailableLessons([]);
    }
  }, [examInfo.grade, examInfo.fieldTitle, examInfo.book, examInfo.chapter]);

  useEffect(() => {
    if (!editingId) resetQuestionForm();
  }, [questionType]);

  // ===== هندلرهای تغییرات (برای سایر فیلدها) =====
  const handleExamInfoChange = (e) => {
    const { name, value, type, checked } = e.target;
    setExamInfo(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

const handleExamImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  if (file.size > 2 * 1024 * 1024) {
    alert('حجم تصویر نباید بیشتر از ۲ مگابایت باشد');
    e.target.value = '';
    return;
  }
  const oldImage = examInfo.image;
  setIsUploadingExamImage(true);
  try {
    const path = await uploadImage(file, currentTeacherId, null, 'cover');
    setExamInfo(prev => ({ ...prev, image: path }));
    if (oldImage) {
      try { await deleteImage(oldImage); } catch (err) { console.warn(err); }
    }
  } catch (error) {
    alert('خطا در آپلود تصویر: ' + error.message);
  } finally {
    setIsUploadingExamImage(false);
  }
};

  // ===== هندلر تاریخ شمسی =====
  const handleDateChange = (value) => {
    if (value) {
      try {
        const gregorianDate = moment(value, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
        setExamInfo(prev => ({ ...prev, date: value, _gregorianDate: gregorianDate }));
      } catch (e) {
        setExamInfo(prev => ({ ...prev, date: value, _gregorianDate: '' }));
      }
    } else {
      setExamInfo(prev => ({ ...prev, date: '', _gregorianDate: '' }));
    }
  };

  // ===== هندلرهای زمان (فقط HH:mm) =====
  const handleStartTimeChange = (value) => {
    setExamInfo(prev => ({ ...prev, startTime: value }));
  };

  const handleEndTimeChange = (value) => {
    setExamInfo(prev => ({ ...prev, endTime: value }));
  };

  // ===== هندلرهای فیلدهای آبشاری =====
  const handleGradeChange = (value) => {
    // 🔽 CHANGED: ریست فیلد هم انجام می‌شه
    setExamInfo((prev) => ({
      ...prev,
      grade: value,
      field: null,
      fieldTitle: '',
      book: '',
      chapter: '',
      subject: '',
    }));
    setCustomGradeConfirmed(false);
    setAvailableFields([]);
    if (value === 'سایر') {
      setCustomGrade('');
      setAvailableBooks([]);
      setAvailableChapters([]);
      setAvailableLessons([]);
    }
  };

  // 🔽 CHANGED: هندلر جدید برای انتخاب رشته
  const handleFieldChange = (value) => {
    if (value === 'سایر') {
      // آینده: می‌تونیم اجازه بدیم رشته دستی وارد بشه
      return;
    }
    const fieldMeta = value ? getFieldMeta(value) : null;
    setExamInfo((prev) => ({
      ...prev,
      field: value || null,
      fieldTitle: fieldMeta?.title || '',
      book: '',
      chapter: '',
      subject: '',
    }));
  };

  const handleBookChange = (value) => {
    setExamInfo(prev => ({ ...prev, book: value, chapter: '', subject: '' }));
    setCustomBookConfirmed(false); // ریست تأیید
    if (value === 'سایر') {
      setCustomBook('');
      setAvailableChapters([]);
      setAvailableLessons([]);
    }
  };

  const handleChapterChange = (value) => {
    setExamInfo(prev => ({ ...prev, chapter: value, subject: '' }));
    setCustomChapterConfirmed(false); // ریست تأیید
    if (value === 'سایر') {
      setCustomChapter('');
      setAvailableLessons([]);
    }
  };

  const handleSubjectChange = (value) => {
    setExamInfo(prev => ({ ...prev, subject: value }));
    setCustomSubjectConfirmed(false); // ریست تأیید
    if (value === 'سایر') {
      setCustomSubject('');
    }
  };

  // ===== توابع مدیریت سوال =====
  const handleQuestionChange = (e) => {
    const { name, value } = e.target;
    setCurrentQuestion(prev => ({ ...prev, [name]: value }));
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...currentQuestion.options];
    newOptions[index] = value;
    setCurrentQuestion(prev => ({ ...prev, options: newOptions }));
  };

  const handleCorrectAnswerChange = (index) => {
    if (currentQuestion.type === 'multi') {
      const newCorrect = [...currentQuestion.correctAnswers];
      const idx = newCorrect.indexOf(index);
      if (idx > -1) newCorrect.splice(idx, 1);
      else newCorrect.push(index);
      setCurrentQuestion(prev => ({ ...prev, correctAnswers: newCorrect }));
    } else {
      setCurrentQuestion(prev => ({ ...prev, correctAnswer: index }));
    }
  };

  const handleFillAnswerChange = (index, value) => {
    const newAnswers = [...currentQuestion.fillAnswers];
    newAnswers[index] = value;
    setCurrentQuestion(prev => ({ ...prev, fillAnswers: newAnswers }));
  };
  const addFillBlank = () => setCurrentQuestion(prev => ({ ...prev, fillAnswers: [...prev.fillAnswers, ''] }));
  const removeFillBlank = (index) => {
    if (currentQuestion.fillAnswers.length > 1) setCurrentQuestion(prev => ({ ...prev, fillAnswers: prev.fillAnswers.filter((_, i) => i !== index) }));
  };

  const handleMatchingPairChange = (index, field, value) => {
    const newPairs = [...currentQuestion.matchingPairs];
    newPairs[index][field] = value;
    setCurrentQuestion(prev => ({ ...prev, matchingPairs: newPairs }));
  };
  const addMatchingPair = () => setCurrentQuestion(prev => ({ ...prev, matchingPairs: [...prev.matchingPairs, { left: '', right: '' }] }));
  const removeMatchingPair = (index) => {
    if (currentQuestion.matchingPairs.length > 1) setCurrentQuestion(prev => ({ ...prev, matchingPairs: prev.matchingPairs.filter((_, i) => i !== index) }));
  };

  const handleOrderItemChange = (index, value) => {
    const newItems = [...currentQuestion.orderItems];
    newItems[index] = value;
    setCurrentQuestion(prev => ({ ...prev, orderItems: newItems }));
  };
  const addOrderItem = () => setCurrentQuestion(prev => ({ ...prev, orderItems: [...prev.orderItems, ''] }));
  const removeOrderItem = (index) => {
    if (currentQuestion.orderItems.length > 2) setCurrentQuestion(prev => ({ ...prev, orderItems: prev.orderItems.filter((_, i) => i !== index) }));
  };

const handleQuestionImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  if (file.size > 2 * 1024 * 1024) {
    alert('حجم تصویر نباید بیشتر از ۲ مگابایت باشد');
    e.target.value = '';
    return;
  }
  const oldImage = currentQuestion.image;
  setIsUploadingQuestionImage(true);
  try {
    const tempId = editingId || 'temp_' + Date.now();
    const path = await uploadImage(file, currentTeacherId, null, 'question', tempId);
    setCurrentQuestion(prev => ({ ...prev, image: path }));
    if (oldImage) {
      try { await deleteImage(oldImage); } catch (err) { console.warn(err); }
    }
  } catch (error) {
    alert('خطا در آپلود تصویر سوال: ' + error.message);
  } finally {
    setIsUploadingQuestionImage(false);
  }
};
  const removeQuestionImage = async () => {
  if (currentQuestion.image) {
    await deleteImage(currentQuestion.image);
  }
  setCurrentQuestion(prev => ({ ...prev, image: null }));
};

  const handleQuestionFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) { alert('حجم فایل نباید بیشتر از ۱۰ مگابایت باشد'); e.target.value = ''; return; }
      const reader = new FileReader();
      reader.onloadend = () => setCurrentQuestion(prev => ({ ...prev, file: reader.result }));
      reader.readAsDataURL(file);
    }
  };
  const removeQuestionFile = () => setCurrentQuestion(prev => ({ ...prev, file: null }));

  const handleConditionChange = (condition) => setCurrentQuestion(prev => ({ ...prev, conditional: condition }));

  // ===== اعتبارسنجی سوال =====
  const validateQuestion = () => {
    if (!currentQuestion.question || currentQuestion.question.trim() === '') { alert('لطفاً متن سوال را وارد کنید.'); return false; }
    const type = currentQuestion.type;
    if (type === 'multiple' || type === 'multi') {
      const validOptions = currentQuestion.options.filter(opt => opt.trim() !== '');
      if (validOptions.length < 2) { alert('لطفاً حداقل دو گزینه معتبر وارد کنید.'); return false; }
      if (type === 'multiple' && (currentQuestion.correctAnswer >= currentQuestion.options.length || !currentQuestion.options[currentQuestion.correctAnswer]?.trim())) { alert('لطفاً گزینه صحیح را انتخاب کنید.'); return false; }
      if (type === 'multi' && currentQuestion.correctAnswers.length === 0) { alert('لطفاً حداقل یک گزینه صحیح انتخاب کنید.'); return false; }
    }
    if (type === 'fill' && currentQuestion.fillAnswers.filter(a => a.trim() !== '').length === 0) { alert('لطفاً حداقل یک پاسخ برای جای خالی وارد کنید.'); return false; }
    if (type === 'matching' && currentQuestion.matchingPairs.filter(p => p.left.trim() !== '' && p.right.trim() !== '').length < 2) { alert('لطفاً حداقل دو جفت معتبر برای سوال تطبیقی وارد کنید.'); return false; }
    if (type === 'ordering' && currentQuestion.orderItems.filter(item => item.trim() !== '').length < 2) { alert('لطفاً حداقل دو آیتم برای مرتب‌سازی وارد کنید.'); return false; }
    if (toNumber(currentQuestion.score) <= 0) { alert('نمره سوال باید بزرگتر از صفر باشد.'); return false; }
    return true;
  };

  const addQuestion = () => {
    if (!editingId) {
      const newScore = toNumber(currentQuestion.score, 0);
      if (totalScore + newScore > 20) {
        alert(`⚠️ با افزودن این سوال مجموع نمرات از ۲۰ بیشتر می‌شود.\nمجموع فعلی: ${totalScore} از ۲۰`);
        return;
      }
    }

    if (!validateQuestion()) return;
    const newQuestion = {
      id: currentQuestion.id || Date.now().toString(36) + Math.random().toString(36).substring(2, 9),
      type: currentQuestion.type,
      question: sanitizeHtmlGlobal(currentQuestion.question.trim()),
      options: [...currentQuestion.options],
      correctAnswer: currentQuestion.correctAnswer,
      correctAnswers: [...currentQuestion.correctAnswers],
      fillAnswers: [...currentQuestion.fillAnswers],
      score: toNumber(currentQuestion.score, 1),
      image: currentQuestion.image || null,
      file: currentQuestion.file || null,
      required: currentQuestion.required || false,
      timeLimit: currentQuestion.timeLimit || null,
      conditional: currentQuestion.conditional || null,
      mathFormula: currentQuestion.mathFormula || '',
      matchingPairs: currentQuestion.type === 'matching' ? [...currentQuestion.matchingPairs] : [],
      orderItems: currentQuestion.type === 'ordering' ? [...currentQuestion.orderItems] : [],
      isEssay: currentQuestion.type === 'essay' || currentQuestion.type === 'file',
    };
    if (editingId) {
      setQuestions(questions.map(q => q.id === editingId ? newQuestion : q));
      setEditingId(null);
    } else {
      setQuestions([...questions, newQuestion]);
    }
    resetQuestionForm();
  };

  const resetQuestionForm = () => {
    const type = questionType;
    setCurrentQuestion({
      id: null, type, question: '', options: ['','','',''], correctAnswer: 0,
      correctAnswers: [], fillAnswers: [''], score: 1, image: null, file: null,
      required: false, timeLimit: null, conditional: null, mathFormula: '',
      matchingPairs: [{ left: '', right: '' }], orderItems: ['','',''],
    });
    if (fileInputRef.current) fileInputRef.current.value = '';
    if (imageInputRef.current) imageInputRef.current.value = '';
  };

  const editQuestion = (id) => {
    const q = questions.find(q => q.id === id);
    if (q) {
      setQuestionType(q.type);
      setCurrentQuestion({
        id: q.id,
        type: q.type,
        question: q.question,
        options: q.options || ['','','',''],
        correctAnswer: q.correctAnswer || 0,
        correctAnswers: q.correctAnswers || [],
        fillAnswers: q.fillAnswers || [''],
        score: q.score || 1,
        image: q.image || null,
        file: q.file || null,
        required: q.required || false,
        timeLimit: q.timeLimit || null,
        conditional: q.conditional || null,
        mathFormula: q.mathFormula || '',
        matchingPairs: q.matchingPairs || [{ left: '', right: '' }],
        orderItems: q.orderItems || ['','',''],
      });
      setEditingId(id);

      setTimeout(() => {
        if (addQuestionAreaRef.current) {
          addQuestionAreaRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }, 100);
    }
  };

  const removeQuestion = async (id) => {
    const msg = 'آیا از حذف این سوال مطمئن هستید؟';
    const ok = typeof window.askConfirm === 'function'
      ? await window.askConfirm(msg)
      : window.confirm(msg);
    if (ok) setQuestions(questions.filter(q => q.id !== id));
  };
  const duplicateQuestion = (id) => {
    const q = questions.find(q => q.id === id);
    if (q) {
      const newScore = toNumber(q.score, 0);
      if (totalScore + newScore > 20) {
        alert(`⚠️ با کپی کردن این سوال مجموع نمرات از ۲۰ بیشتر می‌شود.\nمجموع فعلی: ${totalScore} از ۲۰`);
        return;
      }
      setQuestions([...questions, { ...q, id: Date.now().toString(36) + Math.random().toString(36).substring(2, 9), question: q.question + ' (کپی)' }]);
    }
  };
  const moveQuestion = (index, direction) => {
    const newQuestions = [...questions];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    if (targetIndex < 0 || targetIndex >= questions.length) return;
    [newQuestions[index], newQuestions[targetIndex]] = [newQuestions[targetIndex], newQuestions[index]];
    setQuestions(newQuestions);
  };

  // ============================================================
  // ===== اعتبارسنجی فرم (با پشتیبانی از "سایر" و Step Quiz) =====
  // ============================================================
  const validateExam = () => {
    const newErrors = {};

    // 🆕 در Step Quiz Mode فقط فیلدهای مرتبط با آزمون مرحله چک می‌شن
    // (چون grade/book/date/subject/chapter از پروژه می‌آن، نه از کاربر)
    if (isStepQuizMode) {
      if (!examInfo.title?.trim()) {
        newErrors.title = 'عنوان آزمون الزامی است';
      }
      if (!examInfo.duration || toNumber(examInfo.duration) <= 0) {
        newErrors.duration = 'مدت زمان آزمون الزامی است';
      }
      if (questions.length === 0) {
        newErrors.questions = 'حداقل یک سوال اضافه کنید';
      } else {
        const totalScoreCalc = questions.reduce((sum, q) => sum + toNumber(q.score, 0), 0);
        if (Math.abs(totalScoreCalc - 20) > 0.01) {
          newErrors.totalScore = `مجموع نمرات باید دقیقاً ۲۰ باشد (در حال حاضر ${totalScoreCalc.toFixed(2)})`;
        }
      }
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }

    // ===== جریان عادی (آزمون گروهی / عمومی / چالش) =====
    // عنوان
    if (!examInfo.title.trim()) newErrors.title = 'عنوان آزمون الزامی است';

    // کتاب
    if (examInfo.book === 'سایر') {
      if (!customBook.trim()) newErrors.book = 'لطفاً نام کتاب را وارد کنید';
    } else if (!examInfo.book.trim()) {
      newErrors.book = 'کتاب الزامی است';
    }

    // تاریخ
    if (!examInfo.isGlobal && !examInfo.date.trim()) newErrors.date = 'تاریخ برگزاری الزامی است';

    // پایه
    if (examInfo.grade === 'سایر') {
      if (!customGrade.trim()) newErrors.grade = 'لطفاً نام پایه را وارد کنید';
    } else if (!examInfo.grade.trim()) {
      newErrors.grade = 'پایه تحصیلی الزامی است';
    }

    // رشته (فقط ۱۰-۱۲)
    if (examInfo.grade && curriculumNeedsField(examInfo.grade)) {
      if (!examInfo.field) {
        newErrors.field = 'انتخاب رشته برای پایه‌های متوسطه دوم الزامی است';
      }
    }

    // مدت زمان
    if (!examInfo.duration || toNumber(examInfo.duration) <= 0) {
      newErrors.duration = 'مدت زمان آزمون الزامی است';
    }

    // فیلدهای مخصوص آزمون عمومی
    if (examInfo.isGlobal) {
      if (examInfo.grade === 'سایر') {
        if (!customGrade.trim()) newErrors.grade = 'لطفاً نام پایه را وارد کنید';
      } else if (!examInfo.grade.trim()) {
        newErrors.grade = 'پایه تحصیلی برای آزمون عمومی الزامی است';
      }
      if (examInfo.chapter === 'سایر') {
        if (!customChapter.trim()) newErrors.chapter = 'لطفاً نام فصل را وارد کنید';
      } else if (!examInfo.chapter.trim()) {
        newErrors.chapter = 'فصل برای آزمون عمومی الزامی است';
      }
    }

    // سوالات
    if (questions.length === 0) {
      newErrors.questions = 'حداقل یک سوال اضافه کنید';
    } else {
      const totalScoreCalc = questions.reduce((sum, q) => sum + toNumber(q.score, 0), 0);
      if (totalScoreCalc !== 20) {
        newErrors.totalScore = `مجموع نمرات باید دقیقاً ۲۰ باشد (در حال حاضر ${totalScoreCalc})`;
      }
    }

    // زمان
    if (examInfo.startTime && examInfo.endTime) {
      if (examInfo.startTime >= examInfo.endTime) {
        newErrors.timeRange = 'زمان شروع باید قبل از زمان پایان باشد';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ============================================================
  // ===== تابع تولید PDF شبیه امتحان واقعی =====
  // ============================================================
  const goToPdfEditor = () => {
  // 🆕 قبل از رفتن به PDF، state رو ذخیره کن
  try {
    localStorage.setItem('exam-pdf-backup', JSON.stringify({
      examInfo, questions,
      customGrade, customBook, customChapter, customSubject,
      customGradeConfirmed, customBookConfirmed,
      customChapterConfirmed, customSubjectConfirmed,
    }));
  } catch {}
  navigate('/exams/exampdf', { state: { examData: { ...examInfo, questions } } });
};

  // ============================================================
  // ===== ذخیره آزمون (با پشتیبانی کامل از "سایر") =====
  // ============================================================
  // CreateExam.jsx - بخش handleSave اصلاح شده کامل

const handleSave = useCallback(
  async (publish = false) => {
    if (isSubmitting) return;

    if (publish && !isTotalScoreValid) {
      alert(`⚠️ برای انتشار، مجموع نمرات باید دقیقاً ۲۰ باشد.\nمجموع فعلی: ${totalScore} از ۲۰`);
      return;
    }

    // 🆕 Step Quiz Mode — شاخه‌ی مستقل با ذخیره‌سازی متفاوت
    if (isStepQuizMode && stepQuizOnSave) {
      if (!validateExam()) {
        alert('لطفاً تمام فیلدهای الزامی را تکمیل کنید.');
        return;
      }
      setIsSubmitting(true);
      setSaving(true);
      try {
        const result = await stepQuizOnSave({
          ...examInfo,
          questions: questions.map((q) => ({
            ...q,
            question: sanitizeHtmlGlobal(q.question),
            isEssay: q.type === 'essay' || q.type === 'file',
          })),
        });
        if (result?.ok) {
          // 🆕 بعد از ذخیره‌ی موفق، از onSuccess استفاده کن (نه onCancel)
          // چون onCancel مرحله‌ی بدون quizId رو پاک می‌کنه
          if (stepQuizOnSuccess) {
            stepQuizOnSuccess();
          } else {
            stepQuizOnCancel?.(); // fallback
          }
        } else {
          alert('⚠️ ذخیره‌سازی آزمون مرحله با مشکل مواجه شد. لطفاً دوباره تلاش کنید.');
        }
      } finally {
        setSaving(false);
        setIsSubmitting(false);
      }
      return;
    }

    if (!validateExam()) {
      alert('لطفاً تمام فیلدهای الزامی را تکمیل کنید.');
      return;
    }

    setIsSubmitting(true);
    setSaving(true);

    try {
      let finalTeamId = examInfo.teamId || teacherTeamId;

      if (examInfo.isGlobal) {
        finalTeamId = null;
      } else {
        if (!finalTeamId || finalTeamId === 'no-group') {
          const storedTeam = localStorage.getItem('team');
          if (storedTeam) {
            try {
              const team = JSON.parse(storedTeam);
              if (team && team.id) finalTeamId = team.id;
            } catch {
              /* ignore */
            }
          }
        }
        if (!finalTeamId || finalTeamId === 'no-group') {
          const storedMembers = localStorage.getItem('teamMembers');
          if (storedMembers) {
            try {
              const members = JSON.parse(storedMembers);
              const teacherMember = members.find(
                (m) => m.studentId === currentTeacherId && m.status === 'active'
              );
              if (teacherMember) finalTeamId = teacherMember.teamId;
            } catch {
              /* ignore */
            }
          }
        }
        if (!finalTeamId || finalTeamId === 'no-group') finalTeamId = null;
      }

      const totalStudents = finalTeamId ? (getTeamTotalStudents(finalTeamId) || 0) : 0;

      // ===== تعیین مقادیر نهایی با در نظر گرفتن "سایر" =====
      const finalGrade = examInfo.grade === 'سایر' ? customGrade : examInfo.grade;
      const finalBook = examInfo.book === 'سایر' ? customBook : examInfo.book;
      const finalChapter = examInfo.chapter === 'سایر' ? customChapter : examInfo.chapter;
      const finalSubject = examInfo.subject === 'سایر' ? customSubject : examInfo.subject;

      // ===== ساخت سوالات نهایی با تصاویر =====
      const processedQuestions = questions.map((q) => ({
        ...q,
        question: sanitizeHtmlGlobal(q.question),
        isEssay: q.type === 'essay' || q.type === 'file',
        _isEssayGraded: q.type === 'essay' || q.type === 'file' ? false : true,
      }));

      // ===== آماده‌سازی تاریخ و زمان =====
      let dateToSave = examInfo._gregorianDate;
      if (!dateToSave && examInfo.date) {
        try {
          dateToSave = moment(examInfo.date, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
        } catch (e) {
          dateToSave = '';
        }
      }

      let startTimeToSave = '';
      let endTimeToSave = '';

      if (dateToSave && examInfo.startTime) {
        startTimeToSave = `${dateToSave}T${examInfo.startTime}`;
      }
      if (dateToSave && examInfo.endTime) {
        endTimeToSave = `${dateToSave}T${examInfo.endTime}`;
      }

      // ===== ساخت آبجکت آزمون =====
      const examData = {
        ...examInfo,
        date: dateToSave,
        startTime: startTimeToSave,
        endTime: endTimeToSave,
        questions: processedQuestions,
        published: publish,
        totalStudents: examInfo.isGlobal ? 0 : totalStudents,
        status: publish ? 'فعال' : 'در انتظار',
        statusType: publish ? 'active' : 'pending',
        teamId: examInfo.isGlobal ? null : finalTeamId,
        teacherId: examInfo.teacherId || currentTeacherId,
        needsCorrection: processedQuestions.some((q) => q.isEssay),
        createdAt: isEditing ? existingExam?.createdAt : new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        isGlobal: examInfo.isGlobal,
        grade: finalGrade,
        field: examInfo.field || null,
        fieldTitle: examInfo.fieldTitle || '',
        subject: finalSubject,
        book: finalBook,
        chapter: finalChapter,
      };

      // ================================================================
      // =====  🚀 مرحله‌ی ذخیره‌سازی آزمون و مدیریت تصاویر سوالات  =====
      // ================================================================

      // ---- مرحله ۱: ذخیره آزمون ----
      let savedExam;
      if (isEditing && examId) {
        updateExam(examId, examData);
        savedExam = getExam(examId);
      } else {
        const newExam = addExam(examData);
        savedExam = newExam;
      }

      if (!savedExam) {
        throw new Error('ذخیره‌سازی آزمون با شکست مواجه شد.');
      }

      // ---- مرحله ۲: بررسی وجود تصاویر موقت ----
      let needsImageUpdate = false;
      let tempId = null;
      for (const q of processedQuestions) {
        if (q.image && q.image.includes('temp_')) {
          needsImageUpdate = true;
          const match = q.image.match(/temp_[^/]+/);
          if (match) {
            tempId = match[0];
            break;
          }
        }
      }

      // ---- مرحله ۳: انتقال تصاویر و به‌روزرسانی مسیرها ----
      if (needsImageUpdate && tempId && savedExam.id) {
        try {
          await moveExamImages(currentTeacherId, savedExam.id, tempId);

          // 🆕 آپدیت مسیر تصویر اصلی آزمون (cover) — چون در moveExamImages
          //    کل پوشه‌ی temp به examId منتقل می‌شود، مسیر دیتابیس هم باید عوض شود.
          let updatedExamImage = savedExam.image;
          if (updatedExamImage && updatedExamImage.includes(`/exams/${currentTeacherId}/temp/`)) {
            updatedExamImage = updatedExamImage.replace(
              `/exams/${currentTeacherId}/temp/`,
              `/exams/${currentTeacherId}/${savedExam.id}/`
            );
          }

          const updatedQuestions = processedQuestions.map((q) => {
            if (q.image && q.image.includes('temp_')) {
              const newPath = q.image.replace(
                `/exams/${currentTeacherId}/temp/`,
                `/exams/${currentTeacherId}/${savedExam.id}/`
              );
              return { ...q, image: newPath };
            }
            return q;
          });

          updateExam(savedExam.id, {
            ...savedExam,
            image: updatedExamImage,          // 🆕
            questions: updatedQuestions,
          });

          console.log('✅ تصاویر با موفقیت به پوشه نهایی منتقل شدند.');
        } catch (moveError) {
          console.error('❌ خطا در انتقال تصاویر:', moveError);
          alert('⚠️ تصاویر با موفقیت آپلود شدند اما انتقال به پوشه نهایی با مشکل مواجه شد. لطفاً با پشتیبانی تماس بگیرید.');
        }
      }



            // ---- مرحله ۴: هدایت به صفحه‌ی معلم ----
      // 🆕 draft دیگر لازم نیست — پاکش کن
      if (DRAFT_KEY) {
        try { localStorage.removeItem(DRAFT_KEY); } catch {}
      }
      
      // ---- مرحله ۴: هدایت به صفحه‌ی معلم ----
      navigate('/exams/teacher');
    } catch (error) {
      console.error('Error saving exam:', error);
      alert(error.message || 'خطا در ذخیره آزمون. لطفاً دوباره تلاش کنید.');
    } finally {
      setSaving(false);
      setIsSubmitting(false);
    }
  },
  [
    examInfo,
    questions,
    teacherTeamId,
    currentTeacherId,
    isEditing,
    examId,
    addExam,
    updateExam,
    navigate,
    getTeamTotalStudents,
    getExam,
    isSubmitting,
    totalScore,
    isTotalScoreValid,
    existingExam,
    customGrade,
    customBook,
    customChapter,
    customSubject,
    moveExamImages,
    // 🆕 Step Quiz deps
    isStepQuizMode,
    stepQuizOnSave,
    stepQuizOnCancel,
    stepQuizOnSuccess,   // 🆕
  ]
);

  const handlePublish = () => handleSave(true);

  const exportQuestions = () => {
    if (questions.length === 0) { alert('هیچ سوالی برای خروجی وجود ندارد.'); return; }
    const text = questions.map((q, idx) => {
      let output = `سوال ${idx + 1}: ${q.question}\nنوع: ${q.type}\nنمره: ${toNumber(q.score, 1)}\n`;
      if (q.type === 'multiple' || q.type === 'multi') {
        q.options.forEach((opt, oi) => output += `  ${String.fromCharCode(65 + oi)}. ${opt}\n`);
        if (q.type === 'multiple') output += `پاسخ صحیح: ${String.fromCharCode(65 + q.correctAnswer)}\n`;
        else output += `پاسخ‌های صحیح: ${q.correctAnswers.map(i => String.fromCharCode(65 + i)).join(', ')}\n`;
      } else if (q.type === 'fill') output += `پاسخ‌ها: ${q.fillAnswers.join(', ')}\n`;
      else if (q.type === 'essay' || q.type === 'file') output += `(سوال تشریحی - نیاز به تصحیح دستی)\n`;
      else if (q.type === 'matching') {
        output += `جفت‌های تطبیقی:\n`;
        q.matchingPairs.forEach((p, mi) => output += `  ${mi + 1}. ${p.left} ⟷ ${p.right}\n`);
      } else if (q.type === 'ordering') {
        output += `آیتم‌های مرتب‌سازی:\n`;
        q.orderItems.forEach((item, oi) => output += `  ${oi + 1}. ${item}\n`);
      } else if (q.type === 'truefalse') output += `پاسخ صحیح: ${q.correctAnswer === 0 ? 'صحیح' : 'غلط'}\n`;
      if (q.mathFormula) output += `فرمول: ${q.mathFormula}\n`;
      return output;
    }).join('\n---\n');

    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `سوالات_${examInfo.title || 'آزمون'}.txt`;
    a.click();
    URL.revokeObjectURL(url);
    alert('✅ فایل TXT دانلود شد');
  };

  // ===== رندر فیلدهای نوع سوال =====
  const renderQuestionTypeFields = () => {
    const { type } = currentQuestion;
    if (type === 'multiple' || type === 'multi') {
      return (
        <div className="optionsSection">
          <label className="fieldLabel">گزینه‌ها:</label>
          {currentQuestion.options.map((opt, idx) => (
            <div key={idx} className="optionRow">
              <input 
                type="text" 
                className="optionInput" 
                placeholder={`گزینه ${String.fromCharCode(65 + idx)}`} 
                value={opt} 
                onChange={e => handleOptionChange(idx, e.target.value)} 
              />
              <label className="radioLabel">
                <input 
                  type={type === 'multiple' ? 'radio' : 'checkbox'} 
                  name="correctAnswer" 
                  checked={type === 'multiple' ? currentQuestion.correctAnswer === idx : currentQuestion.correctAnswers.includes(idx)} 
                  onChange={() => handleCorrectAnswerChange(idx)} 
                />
                {type === 'multiple' ? 'صحیح' : 'انتخاب'}
              </label>
            </div>
          ))}
          <div className="optionsActions">
            <button 
              type="button" 
              className="addOptionBtn" 
              onClick={() => setCurrentQuestion(prev => ({ ...prev, options: [...prev.options, ''] }))}
            >
              + افزودن گزینه
            </button>
            <button 
              type="button" 
              className={`removeLastOptionBtn ${currentQuestion.options.length <= 2 ? 'disabled' : ''}`}
              onClick={() => {
                if (currentQuestion.options.length > 2) {
                  const newOptions = currentQuestion.options.slice(0, -1);
                  setCurrentQuestion(prev => ({ ...prev, options: newOptions }));
                }
              }}
              disabled={currentQuestion.options.length <= 2}
              title={currentQuestion.options.length <= 2 ? 'حداقل ۲ گزینه لازم است' : 'حذف آخرین گزینه'}
            >
              − حذف گزینه
            </button>
          </div>
        </div>
      );
    }
    if (type === 'fill') {
      return (
        <div className="fillSection">
          <label className="fieldLabel">پاسخ‌های جای خالی:</label>
          {currentQuestion.fillAnswers.map((answer, idx) => (
            <div key={idx} className="fillRow">
              <input type="text" className="fillInput" placeholder={`پاسخ ${idx + 1}`} value={answer} onChange={e => handleFillAnswerChange(idx, e.target.value)} />
              {currentQuestion.fillAnswers.length > 1 && <button type="button" className="removeFillBtn" onClick={() => removeFillBlank(idx)}>✕</button>}
            </div>
          ))}
          <button type="button" className="addFillBtn" onClick={addFillBlank}>+ افزودن جای خالی دیگر</button>
        </div>
      );
    }
    if (type === 'matching') {
      return (
        <div className="matchingSection">
          <label className="fieldLabel">جفت‌های تطبیقی:</label>
          {currentQuestion.matchingPairs.map((pair, idx) => (
            <div key={idx} className="matchingRow">
              <input type="text" className="matchingInput" placeholder={`سمت چپ ${idx + 1}`} value={pair.left} onChange={e => handleMatchingPairChange(idx, 'left', e.target.value)} />
              <span className="matchingArrow">⟷</span>
              <input type="text" className="matchingInput" placeholder={`سمت راست ${idx + 1}`} value={pair.right} onChange={e => handleMatchingPairChange(idx, 'right', e.target.value)} />
              {currentQuestion.matchingPairs.length > 1 && <button type="button" className="removeMatchingBtn" onClick={() => removeMatchingPair(idx)}>✕</button>}
            </div>
          ))}
          <button type="button" className="addMatchingBtn" onClick={addMatchingPair}>+ افزودن جفت جدید</button>
        </div>
      );
    }
    if (type === 'ordering') {
      return (
        <div className="orderingSection">
          <label className="fieldLabel">آیتم‌های مرتب‌سازی:</label>
          {currentQuestion.orderItems.map((item, idx) => (
            <div key={idx} className="orderingRow">
              <span className="orderingNumber">{idx + 1}.</span>
              <input type="text" className="orderingInput" placeholder={`آیتم ${idx + 1}`} value={item} onChange={e => handleOrderItemChange(idx, e.target.value)} />
              {currentQuestion.orderItems.length > 2 && <button type="button" className="removeOrderBtn" onClick={() => removeOrderItem(idx)}>✕</button>}
            </div>
          ))}
          <button type="button" className="addOrderBtn" onClick={addOrderItem}>+ افزودن آیتم</button>
        </div>
      );
    }
    if (type === 'truefalse') {
      return (
        <div className="truefalseSection">
          <label className="fieldLabel">پاسخ صحیح:</label>
          <label className="radioLabel"><input type="radio" name="truefalse" checked={currentQuestion.correctAnswer === 0} onChange={() => setCurrentQuestion(prev => ({ ...prev, correctAnswer: 0 }))} /> صحیح</label>
          <label className="radioLabel"><input type="radio" name="truefalse" checked={currentQuestion.correctAnswer === 1} onChange={() => setCurrentQuestion(prev => ({ ...prev, correctAnswer: 1 }))} /> غلط</label>
        </div>
      );
    }
    return null;
  };

  const renderQuestionsList = () => {
    if (questions.length === 0) {
      return (
        <div className="emptyQuestions">
          <span>📝</span>
          <p>هنوز سوالی اضافه نشده است.</p>
          <p className="emptyHint">با فرم بالا سوالات خود را طراحی کنید.</p>
        </div>
      );
    }
    return (
      <div className="questionsList">
        {questions.map((q, idx) => (
          <div key={q.id} className="questionItem">
            <div className="questionHeader">
              <span className="questionNumber">سوال {idx + 1}</span>
              <span className={classNames('questionType', q.type)}>
                {q.type === 'multiple' && '✅ تک‌انتخابی'}
                {/*{q.type === 'multi' && '☑️ چندانتخابی'}*/}
                {q.type === 'truefalse' && '⚖️ صحیح/غلط'}
                {q.type === 'fill' && '📝 جای خالی'}
                {q.type === 'essay' && '📄 تشریحی'}
                {/*{q.type === 'file' && '📎 فایل'}*/}
                {q.type === 'matching' && '🔗 تطبیقی'}
                {q.type === 'ordering' && '📊 مرتب‌سازی'}
              </span>
              <span className="questionScore">نمره: {toNumber(q.score, 1)}</span>
              {q.timeLimit && <span className="timeLimitBadge">⏱ {q.timeLimit}ث</span>}
              {q.required && <span className="requiredBadge">الزامی</span>}
              {q.isEssay && <span className="essayBadge">📝 تشریحی</span>}
              <div className="questionActions">
                <button className="editBtn" onClick={() => editQuestion(q.id)} title="ویرایش">✏️</button>
                <button className="duplicateBtn" onClick={() => duplicateQuestion(q.id)} title="کپی">📋</button>
                <button className="removeBtn" onClick={() => removeQuestion(q.id)} title="حذف">🗑️</button>
                <button className="moveUpBtn" onClick={() => moveQuestion(idx, 'up')} disabled={idx === 0}>↑</button>
                <button className="moveDownBtn" onClick={() => moveQuestion(idx, 'down')} disabled={idx === questions.length - 1}>↓</button>
              </div>
            </div>
            <div className="questionText" dangerouslySetInnerHTML={{ __html: sanitizeHtmlGlobal(q.question) }} />
            {q.mathFormula && <div className="mathDisplay"><span className="mathLabel">📐 فرمول: </span><span className="mathFormulaDisplay">{q.mathFormula}</span></div>}
            {q.image && <div className="questionImage"><img src={getImageUrl(q.image)} alt="تصویر سوال" /></div>}
            {q.file && <div className="questionFile"><span>📎 فایل ضمیمه</span></div>}
            {q.type === 'multiple' && (
              <div className="questionOptions">{q.options.map((opt, oi) => <div key={oi} className="questionOption"><span className="optionLetter">{String.fromCharCode(65 + oi)}.</span><span className={q.correctAnswer === oi ? 'correctOption' : ''}>{opt}</span>{q.correctAnswer === oi && <span className="correctBadge">✓</span>}</div>)}</div>
            )}
            {q.type === 'multi' && (
              <div className="questionOptions">{q.options.map((opt, oi) => <div key={oi} className="questionOption"><span className="optionLetter">{String.fromCharCode(65 + oi)}.</span><span className={q.correctAnswers.includes(oi) ? 'correctOption' : ''}>{opt}</span>{q.correctAnswers.includes(oi) && <span className="correctBadge">✓</span>}</div>)}</div>
            )}
            {q.type === 'fill' && <div className="questionFillAnswers"><span className="answerLabel">پاسخ‌ها: </span>{q.fillAnswers.map((ans, fi) => <span key={fi} className="fillAnswerTag">{ans}</span>)}</div>}
            {q.type === 'matching' && <div className="questionMatching">{q.matchingPairs.map((pair, mi) => <div key={mi} className="matchingPairDisplay"><span>{pair.left}</span><span className="matchingArrowDisplay">⟷</span><span>{pair.right}</span></div>)}</div>}
            {q.type === 'ordering' && <div className="questionOrdering">{q.orderItems.map((item, oi) => <span key={oi} className="orderItemDisplay">{oi + 1}. {item}</span>)}</div>}
            {q.conditional && <div className="conditionalDisplay"><span>🔗 شرط: وابسته به سوال {q.conditional.dependsOn + 1}</span></div>}
          </div>
        ))}
      </div>
    );
  };

  const renderPreview = () => {
    if (!showPreview) return null;
    return (
      <section className="card previewCard">
        <h3 className="cardTitle">👁️ پیش‌نمایش آزمون</h3>
        <div className="previewContent">
          <div className="previewHeader">
            <h2>{examInfo.title || 'عنوان آزمون'}</h2>
            <p>{examInfo.book || 'کتاب'}</p>
            {examInfo.isGlobal && !examInfo.isChallenge && (
              <p>
                🌍 آزمون عمومی - {examInfo.grade}
                {examInfo.fieldTitle ? ` (${examInfo.fieldTitle})` : ''}
                {examInfo.subject ? ` - ${examInfo.subject}` : ''}
                {examInfo.chapter ? ` - ${examInfo.chapter}` : ''}
              </p>
            )}
            {examInfo.isChallenge && (
              <p>
                🏆 چالش ویژه - {examInfo.grade}
                {examInfo.fieldTitle ? ` (${examInfo.fieldTitle})` : ''}
                {examInfo.subject ? ` - ${examInfo.subject}` : ''}
                {examInfo.chapter ? ` - ${examInfo.chapter}` : ''}
              </p>
            )}
            <p>تاریخ: {examInfo.date || (examInfo.isGlobal ? 'نامشخص (آزمون عمومی)' : 'نامشخص')}</p>
            <p>تعداد سوالات: {questions.length}</p>
            <p>مدت زمان: {examInfo.duration || 'نامشخص'} دقیقه</p>
            <p>تعداد دانش‌آموزان: {examInfo.isGlobal ? 'همه دانش‌آموزان' : (teamTotalStudents || 0) + ' نفر'}</p>
            <p>مجموع نمرات: {totalScore} از ۲۰</p>
          </div>
          <div className="previewQuestions">
            {questions.map((q, idx) => (
              <div key={q.id} className="previewQuestion">
                <h4>سوال {idx + 1} (نمره: {toNumber(q.score, 1)}){q.type === 'essay' && ' - تشریحی'}{q.type === 'file' && ' - فایل'}{q.type === 'matching' && ' - تطبیقی'}{q.type === 'ordering' && ' - مرتب‌سازی'}</h4>
                <p>{q.question}</p>
                {q.mathFormula && <div className="previewMath">📐 فرمول: {q.mathFormula}</div>}
                {q.image && <div className="previewImage"><img src={getImageUrl(q.image)} alt="تصویر سوال" /></div>}
                {q.type === 'multiple' && <div className="previewOptions">{q.options.map((opt, oi) => <div key={oi} className="previewOption"><span>{String.fromCharCode(65 + oi)}. {opt}</span></div>)}</div>}
                {q.type === 'multi' && <div className="previewOptions">{q.options.map((opt, oi) => <div key={oi} className="previewOption"><span>☑ {String.fromCharCode(65 + oi)}. {opt}</span></div>)}</div>}
                {q.type === 'fill' && <div className="previewFill">{q.fillAnswers.map((_, fi) => <span key={fi} className="previewFillBlank">____</span>)}</div>}
                {q.type === 'truefalse' && <div className="previewTrueFalse"><span>🔘 صحیح</span><span>🔘 غلط</span></div>}
                {q.type === 'essay' && <div className="previewEssay"><textarea className="previewTextarea" placeholder="پاسخ خود را بنویسید..." rows="4" readOnly /></div>}
                {q.type === 'file' && <div className="previewFile"><span>📎 آپلود فایل</span></div>}
                {q.type === 'matching' && <div className="previewMatching">{q.matchingPairs.map((pair, mi) => <div key={mi} className="previewMatchingPair"><span>{pair.left}</span><span>⟷</span><span className="previewMatchingSelect">[انتخاب]</span></div>)}</div>}
                {q.type === 'ordering' && <div className="previewOrdering">{q.orderItems.map((item, oi) => <div key={oi} className="previewOrderItem"><span>⬆⬇ {oi + 1}. {item}</span></div>)}</div>}
                {q.conditional && <div className="previewConditional"><span>🔗 شرط: وابسته به سوال {q.conditional.dependsOn + 1}</span></div>}
              </div>
            ))}
          </div>
        </div>
        <button className="btn btnOutline" onClick={() => setShowPreview(false)}>بستن پیش‌نمایش</button>
      </section>
    );
  };

  // ===== رندر نمایش مجموع نمرات =====
  const renderTotalScoreInfo = () => {
    const isComplete = totalScore === 20;
    const isOver = totalScore > 20;
    const remaining = 20 - totalScore;

    return (
      <div className={`totalScoreInfo ${isComplete ? 'complete' : isOver ? 'over' : ''}`}>
        <div className="totalScoreHeader">
          <span className="totalScoreIcon">📊</span>
          <span className="totalScoreLabel">مجموع نمرات تا الان:</span>
          <span className="totalScoreValue">
            {toPersianDigits(totalScore)} از {toPersianDigits(20)}
          </span>
          {isComplete && <span className="totalScoreCompleteBadge">✅ کامل</span>}
          {isOver && <span className="totalScoreOverBadge">⚠️ بیش از حد</span>}
          {!isComplete && !isOver && (
            <span className="totalScoreRemaining">
              ({toPersianDigits(remaining)} نمره باقی‌مانده)
            </span>
          )}
        </div>
        {isComplete && (
          <div className="totalScoreMessage success">
            ✅ شما به حداکثر مجموع نمره (۲۰) رسیدید. 
            {questions.length > 0 && ' اگر نیاز به سوال بیشتری دارید، نمرات سوالات قبل را پایین بیاورید.'}
          </div>
        )}
        {isOver && (
          <div className="totalScoreMessage error">
            ⚠️ مجموع نمرات از ۲۰ بیشتر شده است. لطفاً نمرات سوالات را کاهش دهید.
          </div>
        )}
        {!isComplete && !isOver && questions.length > 0 && (
          <div className="totalScoreMessage info">
            💡 برای انتشار آزمون، مجموع نمرات باید دقیقاً ۲۰ شود.
          </div>
        )}
        {questions.length === 0 && (
          <div className="totalScoreMessage info">
            📝 حداقل یک سوال اضافه کنید. مجموع نمرات باید ۲۰ شود.
          </div>
        )}
      </div>
    );
  };

  // ===== اگر معلم گروه ندارد =====
  if (!teacherTeamId && !isEditing && !examInfo.isGlobal) {
    return (
      <div className={`create-exam-container ${isDarkMode ? 'dark-mode' : ''}`}>
        <div className="card" style={{ textAlign: 'center', padding: '60px 20px' }}>
          <span style={{ fontSize: '64px' }}>🏫</span>
          <h2 style={{ marginTop: '16px', color: '#1e293b' }}>⚠️ شما به هیچ گروهی متصل نیستید!</h2>
          <p style={{ color: '#64748b', marginTop: '8px' }}>
            برای ساخت آزمون گروهی، بهتر است ابتدا یک گروه ایجاد کنید یا به یک گروه متصل شوید.
            <br />
            <span style={{ fontSize: '14px', color: '#f59e0b' }}>⚠️ در غیر این صورت آزمون بدون گروه ذخیره می‌شود.</span>
            {isAdmin && <br />}
            {isAdmin && <span style={{ fontSize: '14px', color: '#a78bfa' }}>🌟 شما ادمین ویژه هستید و می‌توانید آزمون عمومی بسازید.</span>}
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '20px' }}>
            <button className="btn btnPrimary" onClick={() => navigate('/team-dashboard')}>🚀 رفتن به داشبورد گروه</button>
            <button className="btn btnOutline" onClick={() => setTeacherTeamId('no-group')}>⏩ ادامه بدون گروه</button>
            {isAdmin && (
              <button className="btn btnSecondary" onClick={() => setExamInfo(prev => ({ ...prev, isGlobal: true }))}>
                🌍 ساخت آزمون عمومی
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ===== رندر اصلی =====
  return (
    <div className={`create-exam-container ${isDarkMode ? 'dark-mode' : ''}`}>
      <header className="header">
        <div className="headerLeft">
<button
  className="backBtn"
  onClick={isStepQuizMode ? stepQuizOnCancel : () => navigate('/exams/teacher')}
>
  ← بازگشت
</button>

<h1 className="headerTitle">
  {isStepQuizMode
    ? '📝 ساخت آزمون مرحله'
    : (isEditing ? '✏️ ویرایش آزمون' : '✏️ طراحی آزمون')}
  
  {/* ===== کادر نوع آزمون ===== */}
  {!examInfo.isGlobal && !examInfo.isChallenge && (
    <span className="typeBadge manualBadge">📘 دستی (گروهی)</span>
  )}
  {examInfo.isGlobal && !examInfo.isChallenge && (
    <span className="typeBadge globalBadge">🌍 عمومی</span>
  )}
  {examInfo.isChallenge && (
    <span className="typeBadge challengeBadge">🏆 چالش</span>
  )}
  
  {isEditing && <span className="editBadge">ویرایش</span>}
</h1>
          {isEditing && <span className="editBadge">ویرایش</span>}
        </div>
        <div className="headerActions">
                  {/*<button
            type="button"
            className="themeToggleBtn"
            onClick={toggleTheme}
            title={isDarkMode ? 'حالت روشن' : 'حالت تیره'}
          >
            {isDarkMode ? '☀️' : '🌙'}
          </button>*/}
          <button
  className="btn btnOutline"
  onClick={isStepQuizMode ? stepQuizOnCancel : () => navigate('/exams/teacher')}
>
  انصراف
</button>
          <button className="btn btnSecondary" onClick={() => handleSave(false)} disabled={saving}>{saving ? '⏳ در حال ذخیره...' : '💾 ذخیره موقت'}</button>
          <button 
            className={`btn btnPrimary ${!isTotalScoreValid ? 'btnDisabled' : ''}`} 
            onClick={handlePublish} 
            disabled={saving || !isTotalScoreValid}
            title={!isTotalScoreValid ? 'مجموع نمرات باید ۲۰ باشد' : ''}
          >
            {saving ? '⏳ در حال انتشار...' : isEditing ? '📤 به‌روزرسانی' : '🚀 انتشار'}
          </button>
        </div>
      </header>

      {/* ===== بخش اطلاعات پایه ===== */}
      <section className="card">
        <h3 className="cardTitle">📋 اطلاعات پایه</h3>
        <div className="formGrid">
          <div className="formGroup">
            <label className="fieldLabel">عنوان آزمون <span className="required">*</span></label>
            <input type="text" name="title" className={classNames('textInput', errors.title && 'error')} value={examInfo.title} onChange={handleExamInfoChange} placeholder="مثال: آزمون نهایی فصل ۳ ریاضی" />
            {errors.title && <span className="errorMsg">{errors.title}</span>}
          </div>

          <div className="formGroup">
            <label className="fieldLabel">پایه تحصیلی <span className="required">*</span></label>
            <select
              className={classNames('selectInput', errors.grade && 'error')}
              value={examInfo.grade}
              onChange={(e) => handleGradeChange(e.target.value)}
            >
              <option value="">-- انتخاب پایه --</option>
              {gradeOptions.map(grade => (
                <option key={grade} value={grade}>{grade}</option>
              ))}
              {/*<option value="سایر">سایر (دستی)</option>*/}
            </select>
            {examInfo.grade === 'سایر' && (
              <div style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                <input
                  type="text"
                  className="textInput"
                  placeholder="پایه را وارد کنید..."
                  value={customGrade}
                  onChange={(e) => {
                    setCustomGrade(e.target.value);
                    setCustomGradeConfirmed(false);
                  }}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="btn btnPrimary"
                  style={{ padding: '6px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}
                  onClick={() => {
                    if (customGrade.trim()) {
                      setCustomGradeConfirmed(true);
                    } else {
                      alert('لطفاً مقدار را وارد کنید');
                    }
                  }}
                >
                  ✔ ثبت
                </button>
              </div>
            )}
            {errors.grade && <span className="errorMsg">{errors.grade}</span>}
          </div>

                    {/* 🔽 CHANGED: انتخاب رشته — فقط برای پایه‌های ۱۰-۱۲ */}
          {examInfo.grade && curriculumNeedsField(examInfo.grade) && (
            <div className="formGroup">
              <label className="fieldLabel">
                رشته تحصیلی <span className="required">*</span>
              </label>
              <select
                className={classNames('selectInput', errors.field && 'error')}
                value={examInfo.field || ''}
                onChange={(e) => handleFieldChange(e.target.value)}
              >
                <option value="">-- انتخاب رشته --</option>
                {FIELD_LIST.map((f) => (
                  <option key={f.id} value={f.id}>{f.title}</option>
                ))}
              </select>
              {errors.field && <span className="errorMsg">{errors.field}</span>}
            </div>
          )}

          <div className="formGroup">
            <label className="fieldLabel">کتاب <span className="required">*</span></label>
            <select
              className={classNames('selectInput', errors.book && 'error')}
              value={examInfo.book}
              onChange={(e) => handleBookChange(e.target.value)}
              disabled={!examInfo.grade || (examInfo.grade === 'سایر' && !customGradeConfirmed)}
            >
              <option value="">-- انتخاب کتاب --</option>
              {availableBooks.map(book => (
                <option key={book} value={book}>{book}</option>
              ))}
              {/*<option value="سایر">سایر (دستی)</option>*/}
            </select>
            {examInfo.book === 'سایر' && (
              <div style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                <input
                  type="text"
                  className="textInput"
                  placeholder="کتاب را وارد کنید..."
                  value={customBook}
                  onChange={(e) => {
                    setCustomBook(e.target.value);
                    setCustomBookConfirmed(false);
                  }}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="btn btnPrimary"
                  style={{ padding: '6px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}
                  onClick={() => {
                    if (customBook.trim()) {
                      setCustomBookConfirmed(true);
                    } else {
                      alert('لطفاً مقدار را وارد کنید');
                    }
                  }}
                >
                  ✔ ثبت
                </button>
              </div>
            )}
            {errors.book && <span className="errorMsg">{errors.book}</span>}
          </div>

          <div className="formGroup">
            <label className="fieldLabel">فصل {examInfo.isGlobal && <span className="required">*</span>}</label>
            <select
              className={classNames('selectInput', errors.chapter && 'error')}
              value={examInfo.chapter}
              onChange={(e) => handleChapterChange(e.target.value)}
              disabled={!examInfo.book || (examInfo.book === 'سایر' && !customBookConfirmed)}
            >
              <option value="">-- انتخاب فصل --</option>
              {availableChapters.map(chapter => (
                <option key={chapter} value={chapter}>{chapter}</option>
              ))}
              <option value="سایر">سایر (کل کتاب , فصل ... تا ...)</option>
            </select>
            {examInfo.chapter === 'سایر' && (
              <div style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                <input
                  type="text"
                  className="textInput"
                  placeholder="فصل را وارد کنید..."
                  value={customChapter}
                  onChange={(e) => {
                    setCustomChapter(e.target.value);
                    setCustomChapterConfirmed(false);
                  }}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="btn btnPrimary"
                  style={{ padding: '6px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}
                  onClick={() => {
                    if (customChapter.trim()) {
                      setCustomChapterConfirmed(true);
                    } else {
                      alert('لطفاً مقدار را وارد کنید');
                    }
                  }}
                >
                  ✔ ثبت
                </button>
              </div>
            )}
            {errors.chapter && <span className="errorMsg">{errors.chapter}</span>}
          </div>

          {/*<div className="formGroup">
            <label className="fieldLabel">درس {examInfo.isGlobal && <span className="required">*</span>}</label>
            <select
              className={classNames('selectInput', errors.subject && 'error')}
              value={examInfo.subject}
              onChange={(e) => handleSubjectChange(e.target.value)}
              disabled={!examInfo.chapter || (examInfo.chapter === 'سایر' && !customChapterConfirmed)}
            >
              <option value="">-- انتخاب درس --</option>
              {availableLessons.map(lesson => (
                <option key={lesson} value={lesson}>{lesson}</option>
              ))}
              <option value="سایر">سایر (دستی)</option>
            </select>
            {examInfo.subject === 'سایر' && (
              <div style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                <input
                  type="text"
                  className="textInput"
                  placeholder="درس را وارد کنید..."
                  value={customSubject}
                  onChange={(e) => {
                    setCustomSubject(e.target.value);
                    setCustomSubjectConfirmed(false);
                  }}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="btn btnPrimary"
                  style={{ padding: '6px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}
                  onClick={() => {
                    if (customSubject.trim()) {
                      setCustomSubjectConfirmed(true);
                    } else {
                      alert('لطفاً مقدار را وارد کنید');
                    }
                  }}
                >
                  ✔ ثبت
                </button>
              </div>
            )}
            {errors.subject && <span className="errorMsg">{errors.subject}</span>}
          </div>*/}

          <div className="formGroup">
            <label className="fieldLabel">تاریخ برگزاری {!examInfo.isGlobal && <span className="required">*</span>}</label>
            <PersianDatePicker
              value={examInfo.date}
              onChange={handleDateChange}
              placeholder="انتخاب تاریخ برگزاری..."
              className={classNames('textInput', errors.date && 'error')}
            />
            {errors.date && <span className="errorMsg">{errors.date}</span>}
          </div>

          <div className="formGroup">
            <label className="fieldLabel">مدت زمان (دقیقه) <span className="required">*</span></label>
            <input type="number" name="duration" className={classNames('textInput', errors.duration && 'error')} value={examInfo.duration} onChange={handleExamInfoChange} placeholder="مثال: ۹۰" min="1" required />
            {errors.duration && <span className="errorMsg">{errors.duration}</span>}
          </div>

          {/*{!examInfo.isGlobal && (
            <div className="formGroup">
              <label className="fieldLabel">تعداد دانش‌آموزان گروه</label>
              <input type="text" className="textInput" value={`${teamTotalStudents} نفر`} disabled style={{ background: '#f1f5f9', cursor: 'not-allowed' }} />
            </div>
          )}*/}

          {examInfo.isGlobal && (
            <div className="formGroup">
              <label className="fieldLabel">نوع آزمون</label>
              <input type="text" className="textInput" value={examInfo.isChallenge ? '🏆 چالش ویژه' : '🌍 عمومی - برای همه دانش‌آموزان'} disabled style={{ background: '#f1f5f9', cursor: 'not-allowed', color: examInfo.isChallenge ? '#f59e0b' : '#7c3aed' }} />
            </div>
          )}

          <div className="formGroup">
            <label className="fieldLabel">توضیحات صفحه شروع</label>
            <textarea name="description" className="textArea" value={examInfo.description} onChange={handleExamInfoChange} placeholder="دستورالعمل یا توضیحات تکمیلی..." rows="2" />
          </div>

<div className="formGroup">
  <label className="fieldLabel">تصویر صفحه توضیحات (اختیاری)</label>
  <div className="imageUploadBox">
    {isUploadingExamImage ? (
      <div className="imageUploadSpinner">
        <div className="uploadSpinner" />
        <span>در حال آپلود...</span>
      </div>
    ) : examInfo.image ? (
      <div className="examImagePreview">
        <img src={getImageUrl(examInfo.image)} alt="تصویر شاخص" />
        <button
          type="button"
          className="removeImageBtn"
          onClick={async () => {
            const old = examInfo.image;
            setExamInfo(prev => ({ ...prev, image: null }));
            if (old) {
              try { await deleteImage(old); } catch (err) { console.warn(err); }
            }
          }}
        >✕</button>
      </div>
    ) : (
      <label className="imageUploadLabel">
        <input type="file" accept="image/*" onChange={handleExamImageUpload} style={{ display: 'none' }} />
        <div className="imageUploadIcon">📷</div>
        <div className="imageUploadText">برای انتخاب تصویر کلیک کنید</div>
        <div className="imageUploadHint">PNG، JPG — حداکثر ۲ مگابایت</div>
      </label>
    )}
  </div>
</div>
        </div>
      </section>

      {/* ===== تنظیمات پیشرفته ===== */}
      <section className="card">
        <h3
          className="cardTitle"
          style={{
            cursor: 'pointer',
            userSelect: 'none',
            justifyContent: 'space-between',
            marginBottom: showAdvancedSettings ? '18px' : '0',
          }}
          onClick={() => setShowAdvancedSettings((v) => !v)}
          title={showAdvancedSettings ? 'بستن تنظیمات' : 'باز کردن تنظیمات'}
        >
          <span>⚙️ تنظیمات پیشرفته</span>
          <span
            style={{
              display: 'inline-block',
              transition: 'transform 0.25s ease',
              transform: showAdvancedSettings ? 'rotate(180deg)' : 'rotate(0deg)',
              fontSize: '14px',
              color: 'var(--text-secondary)',
              opacity: 0.75,
            }}
          >
            ▼
          </span>
        </h3>
        {showAdvancedSettings && (
          <div className="settingsGrid">
            <div className="settingItem"><label className="checkboxLabel"><input type="checkbox" name="shuffleQuestions" checked={examInfo.shuffleQuestions} onChange={handleExamInfoChange} /> نمایش تصادفی سوالات</label></div>
          <div className="settingItem"><label className="checkboxLabel"><input type="checkbox" name="shuffleOptions" checked={examInfo.shuffleOptions} onChange={handleExamInfoChange} /> نمایش تصادفی گزینه‌ها</label></div>
          <div className="settingItem"><label className="checkboxLabel"><input type="checkbox" name="showResult" checked={examInfo.showResult} onChange={handleExamInfoChange} /> نمایش نتیجه به کاربر</label></div>
          <div className="settingItem"><label className="checkboxLabel"><input type="checkbox" name="showCorrectAnswers" checked={examInfo.showCorrectAnswers} onChange={handleExamInfoChange} /> نمایش پاسخ‌های صحیح</label></div>

          {/* ===== تنظیمات چالش ویژه (فقط برای ادمین) ===== */}
          {isAdmin && (
            <section className="card" style={{ gridColumn: '1 / -1', marginTop: '12px' }}>
              <h3 className="cardTitle">🏆 تنظیمات چالش ویژه</h3>
              <div className="settingsGrid">
                <div className="settingItem">
                  <label className="checkboxLabel">
                    <input
                      type="checkbox"
                      name="isChallenge"
                      checked={examInfo.isChallenge}
                      onChange={handleExamInfoChange}
                    />
                    این آزمون به عنوان چالش ویژه نمایش داده شود
                  </label>
                  <span style={{ fontSize: '12px', color: '#6b7280', marginRight: '8px', display: 'block' }}>
                    (چالش‌ها در بخش مجزای "چالش‌ها" نمایش داده می‌شوند)
                  </span>
                </div>

                {examInfo.isChallenge && (
                  
                  <>
                  {/* ... فیلدهای قبلی */}
    <div className="settingItem">
      <label className="checkboxLabel">
        <input
          type="checkbox"
          name="isDailyChallenge"
          checked={examInfo.isDailyChallenge}
          onChange={handleExamInfoChange}
        />
        📅 این چالش به عنوان چالش روزانه نمایش داده شود
      </label>
      <span style={{ fontSize: '12px', color: '#6b7280', display: 'block' }}>
        (چالش روزانه فقط در روز برگزاری و تا زمانی که کاربر آن را انجام ندهد، نمایش داده می‌شود)
      </span>
    </div>

                    <div className="settingItem">
                      <label>🌟 عالی (نمره = ۲۰)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsExcellent" className="textInput" value={examInfo.coinsExcellent} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpExcellent" className="textInput" value={examInfo.xpExcellent} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>🎉 خیلی خوب (نمره ۱۶ تا ۱۹)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsVeryGood" className="textInput" value={examInfo.coinsVeryGood} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpVeryGood" className="textInput" value={examInfo.xpVeryGood} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>👍 خوب (نمره ۱۲ تا ۱۵)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsGood" className="textInput" value={examInfo.coinsGood} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpGood" className="textInput" value={examInfo.xpGood} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>💪 نیاز به تلاش (نمره ۸ تا ۱۱)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsNeedsWork" className="textInput" value={examInfo.coinsNeedsWork} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpNeedsWork" className="textInput" value={examInfo.xpNeedsWork} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>📖 غیر قابل قبول (نمره ۴ تا ۷)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsUnacceptable" className="textInput" value={examInfo.coinsUnacceptable} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpUnacceptable" className="textInput" value={examInfo.xpUnacceptable} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>🔄 مردود (نمره ۰ تا ۳)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsFailed" className="textInput" value={examInfo.coinsFailed} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpFailed" className="textInput" value={examInfo.xpFailed} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <p style={{ fontSize: '13px', color: '#64748b', gridColumn: '1 / -1' }}>
                      ⚠️ این جوایز پس از اتمام چالش به کاربر تعلق می‌گیرد.
                    </p>
                  </>
                )}
              </div>
          </section>
        )}

        {/* 🆕 تنظیمات Badge آزمون — فقط ادمین ویژه */}
        {isAdmin && (
          <section className="card" style={{ gridColumn: '1 / -1', marginTop: '12px' }}>
            <h3 className="cardTitle">🏷️ تنظیمات نمایش آزمون (Badgeها)</h3>
            <div className="settingsGrid">

              {/* هزینه ورود */}
              <div className="settingItem">
                <label className="fieldLabel">💰 هزینه ورود (سکه)</label>
                <input
                  type="number"
                  name="requiredCoins"
                  className="textInput"
                  value={examInfo.requiredCoins || 0}
                  onChange={handleExamInfoChange}
                  min="0"
                  placeholder="۰ = رایگان"
                />
                <span style={{ fontSize: 12, color: '#6b7280' }}>
                  {examInfo.requiredCoins > 0
                    ? `🥇 آزمون طلایی (${examInfo.requiredCoins} سکه)`
                    : '🆓 آزمون رایگان'}
                </span>
              </div>

              {/* نشان جدید */}
              <div className="settingItem">
                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    name="forceNew"
                    checked={examInfo.forceNew || false}
                    onChange={handleExamInfoChange}
                  />
                  ✨ نمایش به‌عنوان «جدید» (دستی)
                </label>
                <span style={{ fontSize: 12, color: '#6b7280', marginRight: 28 }}>
                  به‌طور پیش‌فرض، ۲۴ ساعت اول خودکار «جدید» است
                </span>
              </div>

              {examInfo.forceNew && (
                <div className="settingItem">
                  <label className="fieldLabel">مدت نمایش «جدید» (ساعت)</label>
                  <input
                    type="number"
                    name="newBadgeDuration"
                    className="textInput"
                    value={examInfo.newBadgeDuration || 168}
                    onChange={handleExamInfoChange}
                    min="0"
                    step="24"
                    placeholder="۲۴ = روز، ۱۶۸ = هفته"
                  />
                </div>
              )}

              {/* نشان داغ */}
              <div className="settingItem">
                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    name="forceHot"
                    checked={examInfo.forceHot || false}
                    onChange={handleExamInfoChange}
                  />
                  🔥 نمایش به‌عنوان «داغ» (دستی)
                </label>
              </div>

              <div className="settingItem">
                <label className="fieldLabel">آستانه خودکار «داغ» (شرکت‌کننده)</label>
                <input
                  type="number"
                  name="hotThresholdParticipants"
                  className="textInput"
                  value={examInfo.hotThresholdParticipants ?? 1000}
                  onChange={handleExamInfoChange}
                  min="0"
                  placeholder="۱۰۰۰"
                />
                <span style={{ fontSize: 12, color: '#6b7280' }}>
                  اگه تعداد شرکت‌کننده از این بیشتر شد، خودکار «داغ» می‌شود
                </span>
              </div>

              <p style={{ fontSize: 13, color: '#64748b', gridColumn: '1 / -1' }}>
                ⚠️ این تنظیمات فقط برای آزمون‌های عمومی و چالش‌ها کاربرد دارد.
              </p>
            </div>
          </section>
        )}

          <div className="settingItem">
            <label className="fieldLabel" style={{ fontSize: '14px' }}>نحوه نمایش سوالات</label>
            <select name="displayMode" className="selectInput" value={examInfo.displayMode} onChange={handleExamInfoChange}>
              <option value="step">هر مرحله یک سوال</option>
              <option value="all">همه سوالات در یک صفحه</option>
            </select>
          </div>

          <div className="settingItem">
            <label className="fieldLabel" style={{ fontSize: '14px' }}>زمان شروع (ورود)</label>
            <TimePicker
              value={examInfo.startTime}
              onChange={handleStartTimeChange}
              placeholder="ساعت شروع"
              label="زمان شروع"
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>⏰ از این زمان به بعد دانش‌آموزان می‌توانند وارد آزمون شوند</span>
          </div>
          <div className="settingItem">
            <label className="fieldLabel" style={{ fontSize: '14px' }}>زمان پایان (ورود)</label>
            <TimePicker
              value={examInfo.endTime}
              onChange={(value) => {
                if (!examInfo.startTime && value) {
                  alert('⚠️ ابتدا زمان شروع را انتخاب کنید');
                  return;
                }
                handleEndTimeChange(value);
              }}
              placeholder="ساعت پایان"
              label="زمان پایان"
              minTime={examInfo.startTime}
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>⏰ بعد از این زمان دانش‌آموزان نمی‌توانند وارد آزمون شوند</span>
          </div>
          {errors.timeRange && <div className="errorMsg" style={{ color: '#dc2626', marginTop: '8px', gridColumn: '1 / -1' }}>⚠️ {errors.timeRange}</div>}
          </div>
        )}
      </section>

      {/* ===== مدیریت سوالات ===== */}
      <section className="card">
        <div className="questionsHeader">
          <h3 className="cardTitle">📝 سوالات آزمون</h3>
          <span className="questionCount">{questions.length} سوال</span>
          {errors.questions && <div className="errorMsg">{errors.questions}</div>}
        </div>
        <div className="addQuestionArea" ref={addQuestionAreaRef}>
          <div className="questionTypeSelector">
            {['multiple','truefalse','fill','essay','matching','ordering'].map(type => (
              <button key={type} className={classNames('typeBtn', questionType === type && 'active')} onClick={() => { setQuestionType(type); if (!editingId) setCurrentQuestion(prev => ({ ...prev, type })); }}>
                {type === 'multiple' && '✅ تک‌انتخابی'}
                {/*{type === 'multi' && '☑️ چندانتخابی'}*/}
                {type === 'truefalse' && '⚖️ صحیح/غلط'}
                {type === 'fill' && '📝 جای خالی'}
                {type === 'essay' && '📄 تشریحی'}
                {/*{type === 'file' && '📎 فایل'}*/}
                {type === 'matching' && '🔗 تطبیقی'}
                {type === 'ordering' && '📊 مرتب‌سازی'}
              </button>
            ))}
          </div>
          <div className="questionForm">
            <div className="formGroup">
              <label className="fieldLabel">متن سوال</label>
              <SimpleTextEditor
                value={currentQuestion.question}
                onChange={(value) => setCurrentQuestion(prev => ({ ...prev, question: value }))}
                placeholder="متن سوال را وارد کنید..."
              />
            </div>

            {renderQuestionTypeFields()}

<div className="questionFooter">
  <div className="formGroup" style={{ maxWidth: '120px' }}><label className="fieldLabel">نمره</label><input type="number" name="score" className="textInput" value={currentQuestion.score} onChange={handleQuestionChange} min="0.5" step="0.5" /></div>

  {/* 🆕 پیش‌نمایش تصویر سوال — دقیقاً مثل تصویر صفحه توضیحات */}
<div className="formGroup" style={{ maxWidth: '200px' }}>
  <label className="fieldLabel">تصویر سوال (اختیاری)</label>
  <div className="imageUploadBox">
    {isUploadingQuestionImage ? (
      <div className="imageUploadSpinner small">
        <div className="uploadSpinner small" />
        <span>آپلود...</span>
      </div>
    ) : currentQuestion.image ? (
      <div className="examImagePreview">
        <img src={getImageUrl(currentQuestion.image)} alt="تصویر سوال" />
        <button type="button" className="removeImageBtn" onClick={removeQuestionImage}>✕</button>
      </div>
    ) : (
      <label className="imageUploadLabel small">
        <input
          type="file"
          ref={imageInputRef}
          accept="image/*"
          onChange={handleQuestionImageUpload}
          style={{ display: 'none' }}
        />
        <div className="imageUploadIcon small">📷</div>
        <div className="imageUploadText small">افزودن تصویر</div>
      </label>
    )}
  </div>
</div>

  {/*<div className="formGroup" style={{ maxWidth: '150px' }}><label className="fieldLabel">فایل ضمیمه</label>...</div>*/}
  <div className="formGroup" style={{ maxWidth: '150px' }}><label className="checkboxLabel"><input type="checkbox" name="required" checked={currentQuestion.required} onChange={e => setCurrentQuestion(prev => ({ ...prev, required: e.target.checked }))} /> اجباری</label></div>
  <button 
    type="button" 
    className={`btn btnSuccess ${!canAddQuestion ? 'btnDisabled' : ''}`} 
    onClick={addQuestion}
    disabled={!canAddQuestion}
    title={!canAddQuestion ? 'مجموع نمرات به ۲۰ رسیده است' : ''}
  >
    {editingId ? '✏️ ویرایش سوال' : '➕ افزودن سوال'}
  </button>
  {editingId && <button type="button" className="btn btnOutline" onClick={() => { resetQuestionForm(); setEditingId(null); }}>انصراف</button>}
</div>
            {/* نمایش مجموع نمرات */}
            <div className="totalScoreWrapper">
              {renderTotalScoreInfo()}
            </div>
          </div>
        </div>
        <div className="questionsContainer">{renderQuestionsList()}</div>
      </section>

      {renderPreview()}

      {/* ===== محتوای PDF مخفی ===== */}
      <div style={{ display: 'none' }}>
        <div ref={pdfContentRef} style={{
          fontFamily: 'Tahoma, sans-serif',
          padding: '30px 35px',
          direction: 'rtl',
          maxWidth: '100%',
          backgroundColor: '#ffffff',
          color: '#1a1a1a',
          fontSize: '14px',
          lineHeight: '1.8'
        }}>
          {/* ===== سربرگ ===== */}
          <div style={{ textAlign: 'center', borderBottom: '2px solid #000', paddingBottom: '15px', marginBottom: '25px' }}>
            <h1 style={{ fontSize: '22px', fontWeight: 'bold', margin: '0 0 5px 0' }}>
              آزمون درس {examInfo.subject || ''}
            </h1>
            <h2 style={{ fontSize: '18px', fontWeight: '600', margin: '5px 0' }}>
              {examInfo.title || 'عنوان آزمون'}
            </h2>
            <p style={{ fontSize: '14px', margin: '4px 0', color: '#333' }}>
              {examInfo.grade || ''} - {examInfo.book || ''} {examInfo.chapter ? `- فصل ${examInfo.chapter}` : ''}
            </p>
            <p style={{ fontSize: '13px', margin: '4px 0', color: '#555' }}>
              تاریخ: {examInfo.date || ''} | مدت زمان: {examInfo.duration || ''} دقیقه | نوبت: {examInfo.isGlobal ? (examInfo.isChallenge ? 'چالش ویژه' : 'عمومی') : 'گروهی'}
            </p>
            <p style={{ fontSize: '13px', margin: '4px 0', color: '#555' }}>
              تعداد سوالات: {questions.length} | مجموع نمرات: {toPersianDigits(totalScore)} از ۲۰
            </p>
          </div>

          {/* ===== نام و نام خانوادگی ===== */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', padding: '10px 0', borderBottom: '1px dashed #ccc' }}>
            <span style={{ fontSize: '14px' }}>
              نام و نام خانوادگی: <span style={{ borderBottom: '1px solid #000', padding: '0 40px 0 0' }}>__________________</span>
            </span>
            <span style={{ fontSize: '14px' }}>
              کلاس: <span style={{ borderBottom: '1px solid #000', padding: '0 30px 0 0' }}>______</span>
            </span>
            <span style={{ fontSize: '14px' }}>
              تاریخ: <span style={{ borderBottom: '1px solid #000', padding: '0 30px 0 0' }}>______</span>
            </span>
          </div>

          {/* ===== دستورالعمل ===== */}
          {examInfo.description && (
            <div style={{ marginBottom: '20px', padding: '10px 15px', background: '#f7f7f7', borderRadius: '6px', border: '1px solid #e0e0e0' }}>
              <p style={{ fontSize: '13px', margin: '0', color: '#444' }}>{examInfo.description}</p>
            </div>
          )}

          {/* ===== سوالات ===== */}
          {questions.map((q, idx) => (
            <div key={q.id} style={{ marginBottom: '22px', padding: '10px 0', borderBottom: '1px dashed #ddd' }}>
              <p style={{ fontWeight: 'bold', fontSize: '15px', margin: '0 0 8px 0', color: '#1a1a1a' }}>
                سوال {toPersianDigits(idx + 1)} {q.score ? `(${toPersianDigits(q.score)} نمره)` : ''}
              </p>
              <p style={{ fontSize: '14px', margin: '0 0 10px 0', lineHeight: '1.9' }}>
                {q.question}
              </p>

              {/* گزینه‌ها */}
              {q.type === 'multiple' && q.options && q.options.length > 0 && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  {q.options.map((opt, oi) => (
                    <p key={oi} style={{ fontSize: '13px', margin: '3px 0' }}>
                      {toPersianLetter(String.fromCharCode(65 + oi))}. {opt}
                    </p>
                  ))}
                </div>
              )}

              {/* چند انتخابی */}
              {q.type === 'multi' && q.options && q.options.length > 0 && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  {q.options.map((opt, oi) => (
                    <p key={oi} style={{ fontSize: '13px', margin: '3px 0' }}>
                      ☐ {toPersianLetter(String.fromCharCode(65 + oi))}. {opt}
                    </p>
                  ))}
                </div>
              )}

              {/* جای خالی */}
              {q.type === 'fill' && q.fillAnswers && q.fillAnswers.length > 0 && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  {q.fillAnswers.map((_, fi) => (
                    <p key={fi} style={{ fontSize: '13px', margin: '3px 0' }}>
                      جای خالی {toPersianDigits(fi + 1)}: ______________
                    </p>
                  ))}
                </div>
              )}

              {/* صحیح/غلط */}
              {q.type === 'truefalse' && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  <p style={{ fontSize: '13px', margin: '3px 0' }}>○ صحیح</p>
                  <p style={{ fontSize: '13px', margin: '3px 0' }}>○ غلط</p>
                </div>
              )}

              {/* تشریحی */}
              {(q.type === 'essay' || q.type === 'file') && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  <div style={{
                    border: '1px solid #aaa',
                    height: '70px',
                    borderRadius: '4px',
                    background: '#fafafa',
                    marginTop: '4px'
                  }}></div>
                  <p style={{ fontSize: '12px', color: '#888', margin: '4px 0 0 0' }}>فضای پاسخ‌دهی</p>
                </div>
              )}

              {/* فرمول */}
              {q.mathFormula && (
                <p style={{ fontSize: '13px', color: '#555', margin: '5px 0' }}>
                  📐 فرمول: {q.mathFormula}
                </p>
              )}
            </div>
          ))}

          {/* ===== پایان برگه ===== */}
          <div style={{ textAlign: 'center', marginTop: '30px', paddingTop: '20px', borderTop: '2px solid #000' }}>
            <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#1a1a1a' }}>با آرزوی موفقیت 🌟</p>
            <p style={{ fontSize: '12px', color: '#888', marginTop: '6px' }}>
              به نام خداوند بخشنده مهربان
            </p>
          </div>
        </div>
      </div>

      <section className="footer">
        {/*<button className="btn btnOutline" onClick={() => setShowPreview(!showPreview)}>👁️ پیش‌نمایش</button>*/}

        <div className="footerRight">
          <button className="btn btnOutline btnLarge" onClick={goToPdfEditor}>
  📄 تبدیل به Pdf
</button>
          <button className="btn btnSecondary btnLarge" onClick={() => handleSave(false)} disabled={saving}>{saving ? '⏳...' : '💾 ذخیره موقت'}</button>
          <button 
            className={`btn btnPrimary btnLarge ${!isTotalScoreValid ? 'btnDisabled' : ''}`} 
            onClick={handlePublish} 
            disabled={saving || !isTotalScoreValid}
            title={!isTotalScoreValid ? 'مجموع نمرات باید ۲۰ باشد' : ''}
          >
            {saving ? '⏳...' : isEditing ? '📤 به‌روزرسانی' : '🚀 انتشار برای دانش آموزان'}
          </button>
        </div>
      </section>
    </div>
  );
};

export default CreateExam;